




// import React, { useState, useEffect } from 'react';
// import './Management.css';
// import { FaTrash, FaEye, FaPrint } from 'react-icons/fa'; // Added FaPrint
// import axios from 'axios';
// import Schedule from './ScheduleOrder';
// import { useLoader } from '../../../../context/LoaderProvider';
// import StandardOrderStatus from './StandardOrderStatus';

// // Add these imports at the top
// import jsPDF from 'jspdf';
// import html2canvas from 'html2canvas';


// const Standardorder = () => {
//   const [activeTab, setActiveTab] = useState('Order Life-Cycle');
//   const [data, setData] = useState([]);
//   const [orders, setOrders] = useState([]);
//   const { showLoader, hideLoader } = useLoader();
//   const [loading, setLoading] = useState(false);
//   const [selectedItems, setSelectedItems] = useState([]);
//   // Add these with your other useState declarations
//   const [isPrinting, setIsPrinting] = useState(false);
//   const [printingOrderId, setPrintingOrderId] = useState(null);
//   // Add with other state variables
//   const [allOrdersForSearch, setAllOrdersForSearch] = useState([]);

//   const [vendorId, setVendorId] = useState(null);
//   const [allOrders, setAllOrders] = useState([]);
//   const [filteredData, setFilteredData] = useState([]);
//   const screenWidth = window.innerWidth;
//   const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
//   // Add these with your other useState declarations:
//   const [pageSize] = useState(10); // Fixed at 10
//   const [totalElements, setTotalElements] = useState(0);
//   const [filteredOrders, setFilteredOrders] = useState([]);
//   // Add new state for receipt
//   const [receiptData, setReceiptData] = useState(null);
//   const [selectedOrderForReceipt, setSelectedOrderForReceipt] = useState(null);

//   const [hasMorePages, setHasMorePages] = useState(true);
//   const [pageNumbers, setPageNumbers] = useState([0]); // For P-1, P, P+1

//   const [statusOrders, setStatusOrders] = useState([]);
//   const [currentPage, setCurrentPage] = useState(0);
//   const [totalPages, setTotalPages] = useState(1);
//   const [isLoadingStatus, setIsLoadingStatus] = useState(false);
//   const [searchQuery, setSearchQuery] = useState('');
//   const [selectedDate, setSelectedDate] = useState("");



//   const containerHeight = window.innerWidth < 768
//     ? '300px'       // Mobile
//     : window.innerWidth < 850
//       ? '300px'     // Below 850px
//       : window.innerWidth < 1400
//         ? '410px'   // Between 850px and 1399px
//         : window.innerWidth < 1600
//           ? '480px' // Between 1400px and 1599px
//           : '640px'; // Above 1600px






//   useEffect(() => {
//     const handleResize = () => setIsMobile(window.innerWidth <= 768);
//     window.addEventListener('resize', handleResize);
//     return () => window.removeEventListener('resize', handleResize);
//   }, []);



//   useEffect(() => {
//     let filtered = [...statusOrders];

//     if (selectedDate) {
//       const s = new Date(selectedDate);
//       s.setHours(0, 0, 0, 0);

//       const e = new Date(selectedDate);
//       e.setHours(23, 59, 59, 999);

//       filtered = filtered.filter(order => {
//         const date = new Date(order.orderDateAndTime);
//         return date >= s && date <= e;
//       });
//     }

//     setFilteredOrders(filtered);
//   }, [selectedDate, statusOrders]);

//   // Fetch orders from API
//   useEffect(() => {
//     if (!vendorId) return;

//     const fetchOrders = async () => {
//       const token = localStorage.getItem("authToken");
//       if (!token) {
//         console.error("Authorization token missing");
//         return;
//       }

//       try {
//         let pageIndex = 0;
//         let allNormalOrders = [];
//         let morePages = true;

//         // 🔵 Fetch ALL PAGINATED ORDERS page by page
//         while (morePages) {
//           const res = await axios.get(
//             `https://backend.maamaas.com/food/api/orders/vendor/paginated/${vendorId}/${pageIndex}/10`,
//             { headers: { Authorization: `Bearer ${token}` } }
//           );

//           const response = res.data;

//           if (!response || !Array.isArray(response.content)) break;

//           const pageData = response.content;

//           if (pageData.length === 0) break;

//           allNormalOrders = [...allNormalOrders, ...pageData];

//           if (pageData.length < 10) {
//             morePages = false;
//           } else {
//             pageIndex++;
//           }
//         }

//         // 🔵 Fetch DINE-IN completed orders
//         const dineInRes = await axios.get(
//           `https://backend.maamaas.com/food/api/cart/get/ordertype=TABLE_DINE_IN/${vendorId}/COMPLETED`,
//           { headers: { Authorization: `Bearer ${token}` } }
//         );

//         const dineInRaw = dineInRes.data || [];

//         const dineInOrders = dineInRaw.map((order) => ({
//           orderId: order.cartId,
//           orderDateAndTime: order.cartDateAndTime || new Date().toISOString(),
//           appType: "Food",
//           orderService: order.orderType,
//           userName: order.userName || "Dine-In User",
//           paymentMethod: order.paymentMethod || "N/A",
//           status: "COMPLETED",
//           grandTotal: order.grandTotal || 0,
//         }));

//         // 🔥 Combine both
//         const allData = [...allNormalOrders, ...dineInOrders];


//         setAllOrders(allData);
//         setFilteredData(allData); // initial display

//       } catch (error) {
//         console.error("Error fetching orders:", error);
//       }
//     };

//     fetchOrders();
//   }, [vendorId]);

//   const [allFilteredOrders, setAllFilteredOrders] = useState([]);

//   // Filter orders whenever selectedDate changes
//   useEffect(() => {
//     if (!selectedDate) {
//       setAllFilteredOrders(allOrders);
//     } else {
//       const filtered = allOrders.filter((order) => {
//         const orderDate = new Date(order.orderDateAndTime)
//           .toISOString()
//           .split("T")[0];
//         return orderDate === selectedDate;
//       });
//       setAllFilteredOrders(filtered);
//     }
//   }, [selectedDate, allOrders]);

//   // Then update pagination based on allFilteredOrders
//   useEffect(() => {
//     if (allFilteredOrders.length > 0) {
//       const startIndex = currentPage * 10;
//       const pageOrders = allFilteredOrders.slice(startIndex, startIndex + 10);

//       const formatted = pageOrders.map(order => ({
//         orderId: order.orderId,
//         orderDateAndTime: order.orderDateAndTime,
//         orderType: order.orderType?.replace(/[_-]/g, "") ?? "N/A",
//         paymentMethod: order.paymentMethod?.replace(/[_-]/g, "") ?? "N/A",
//         status: order.status,
//         grandTotal: order.grandTotal ?? 0,
//       }));

//       setStatusOrders(formatted);
//       setTotalPages(Math.ceil(allFilteredOrders.length / 10));
//     }
//   }, [allFilteredOrders, currentPage]);




//   useEffect(() => {
//     const storedVendorId = localStorage.getItem("vendorId");
//     if (storedVendorId) {
//       setVendorId(storedVendorId);
//     }
//   }, []);
//   useEffect(() => {
//     if (!vendorId) return;

//     fetchOrders(); // Initial fetch

//     const intervalId = setInterval(fetchOrders, 5000); // Poll every 5 seconds
//     return () => clearInterval(intervalId);
//   }, [vendorId]);

//   const [combinedData, setCombinedData] = useState([]);

//   useEffect(() => {
//     if (!vendorId) return;

//     const fetchData = () => {
//       const token = localStorage.getItem("authToken"); // ✅ Retrieve token from storage
//       if (!token) {
//         console.warn("No auth token found. Skipping fetch.");
//         return;
//       }

//       axios
//         .get(
//           `https://backend.maamaas.com/food/api/orders/vendor/${vendorId}`,
//           {
//             headers: {
//               Authorization: `Bearer ${token}`, // ✅ Include token in header
//             },
//           }
//         )
//         .then((res) => setData(res.data))
//         .catch((err) =>
//           console.error("Error fetching orders with token:", err.response?.data || err.message)
//         );
//     };

//     fetchData(); // initial fetch

//     const interval = setInterval(fetchData, 100000); // fetch every 1 second

//     return () => clearInterval(interval); // cleanup
//   }, [vendorId]);

//   const getTotalOrdersCount = async () => {
//     if (!vendorId) return 0;

//     const token = localStorage.getItem("authToken");
//     try {
//       const response = await axios.get(
//         `https://backend.maamaas.com/food/api/orders/vendor/statistics/${vendorId}`,
//         { headers: { Authorization: `Bearer ${token}` } }
//       );

//       return response.data.totalOrders || 0;
//     } catch (error) {
//       console.error("Error fetching total orders count:", error);
//       return 0;
//     }
//   };


//   const fetchPaginatedOrders = async (page = 0) => {
//     if (!vendorId) return;

//     setIsLoadingStatus(true);
//     const token = localStorage.getItem("authToken");

//     try {
//       // 1. Fetc
//       // h current page
//       // showLoader();
//       let apiUrl = `https://backend.maamaas.com/food/api/orders/vendor/paginated/${vendorId}/${page}/10`;

//       const params = new URLSearchParams();
//       if (selectedDate) params.append('date', selectedDate);
//       if (searchQuery.trim() !== '') params.append('search', searchQuery);

//       const queryString = params.toString();
//       if (queryString) apiUrl += `?${queryString}`;

//       const response = await axios.get(apiUrl, {
//         headers: { Authorization: `Bearer ${token}` },
//       });

//       const orders = response.data || [];

//       // 2. Calculate total pages from statistics
//       let calculatedTotalPages = totalPages; // Keep current by default

//       // Only recalculate on first page or when filters change
//       if (page === 0) {
//         if (selectedDate || searchQuery.trim() !== '') {
//           // For filtered/search results, we need to count differently
//           // Fetch all orders and count filtered ones
//           const allResponse = await axios.get(
//             `https://backend.maamaas.com/food/api/orders/vendor/${vendorId}`,
//             { headers: { Authorization: `Bearer ${token}` } }
//           );

//           let allOrders = allResponse.data || [];

//           // Apply same filters
//           if (selectedDate) {
//             allOrders = allOrders.filter(order => {
//               const orderDate = new Date(order.orderDateAndTime)
//                 .toISOString()
//                 .split("T")[0];
//               return orderDate === selectedDate;
//             });
//           }

//           if (searchQuery.trim() !== '') {
//             const query = searchQuery.toLowerCase().trim();
//             allOrders = allOrders.filter(order => {
//               const orderIdMatch = order.orderId?.toString().toLowerCase().includes(query);
//               const userNameMatch = order.userName?.toLowerCase().includes(query);
//               const orderTypeMatch = order.orderType?.toLowerCase().includes(query);
//               return orderIdMatch || userNameMatch || orderTypeMatch;
//             });
//           }

//           calculatedTotalPages = Math.max(1, Math.ceil(allOrders.length / 10));
//         } else {
//           // Normal view - use statistics API
//           const totalOrdersCount = await getTotalOrdersCount();
//           calculatedTotalPages = Math.max(1, Math.ceil(totalOrdersCount / 10));
//         }

//       }

//       // 3. Update state
//       setStatusOrders(orders);
//       setTotalPages(calculatedTotalPages); // ✅ Now this is accurate!
//       setCurrentPage(page);

//     } catch (error) {
//       console.error("Error fetching orders:", error);
//       setStatusOrders([]);
//       setTotalPages(1);
//       setCurrentPage(0);
//     } finally {
//       setIsLoadingStatus(false);
//       // hideLoader();
//     }
//   };




//   // Update goNext and goPrevious functions:
//   const goToFirstPage = () => setCurrentPage(totalPages - totalPages);
//   const goToPreviousPage = () => setCurrentPage(prev => Math.max(0, prev - 1));
//   const goToNextPage = () => setCurrentPage(prev => Math.min(totalPages - 1, prev + 1));
//   const goToLastPage = () => setCurrentPage(totalPages - 1);

//   // Helper to get page numbers to display
//   const getVisiblePages = () => {
//     const pages = [];

//     // Always show current page
//     pages.push(currentPage);

//     // Show previous page if exists
//     if (currentPage > 0) {
//       pages.unshift(currentPage - 1);
//     }

//     // Show next page if exists
//     if (currentPage < totalPages - 1) {
//       pages.push(currentPage + 1);
//     }

//     // If we have less than 3 pages, add more if available
//     if (pages.length < 3) {
//       if (currentPage > 1) {
//         pages.unshift(currentPage - 2);
//       }
//       if (currentPage < totalPages - 2) {
//         pages.push(currentPage + 2);
//       }
//     }

//     // Sort and return unique pages
//     return [...new Set(pages)].sort((a, b) => a - b);
//   };
//   useEffect(() => {
//     if (vendorId && activeTab === 'Status') {
//       if (searchQuery.trim() !== '') {
//         handleSearch();
//       } else {
//         fetchPaginatedOrders(currentPage);
//       }
//     }
//   }, [currentPage, vendorId, activeTab, selectedDate, searchQuery]);

//   // Note: We removed searchQuery from dependencies to prevent auto-search on every keystroke


//   // Add this function near your other functions (after handleSearchOrders)
//   // const handleSearch = async () => {
//   //   if (!vendorId) return;

//   //   // If search is empty, fetch normal orders
//   //   if (searchQuery.trim() === '') {
//   //     fetchPaginatedOrders(0);
//   //     return;
//   //   }

//   //   setIsLoadingStatus(true);
//   //   const token = localStorage.getItem("authToken");

//   //   try {
//   //     // Use the vendor orders API for search
//   //     const response = await axios.get(
//   //       `https://backend.maamaas.com/food/api/orders/vendor/${vendorId}`,
//   //       { headers: { Authorization: `Bearer ${token}` } }
//   //     );

//   //     let allOrders = response.data || [];

//   //     // Apply date filter
//   //     if (selectedDate) {
//   //       allOrders = allOrders.filter(order => {
//   //         const orderDate = new Date(order.orderDateAndTime)
//   //           .toISOString()
//   //           .split("T")[0];
//   //         return orderDate === selectedDate;
//   //       });
//   //     }

//   //     // Apply search filter
//   //     const query = searchQuery.toLowerCase().trim();
//   //     const filteredOrders = allOrders.filter(order => {
//   //       const orderIdMatch = order.orderId?.toString().toLowerCase().includes(query);
//   //       const userNameMatch = order.userName?.toLowerCase().includes(query);
//   //       const orderTypeMatch = order.orderType?.toLowerCase().includes(query);
//   //       return orderIdMatch || userNameMatch || orderTypeMatch;
//   //     });

//   //     // Sort and paginate
//   //     filteredOrders.sort((a, b) => new Date(b.orderDateAndTime) - new Date(a.orderDateAndTime));

//   //     const totalElements = filteredOrders.length;
//   //     const totalPages = Math.max(1, Math.ceil(totalElements / 10));

//   //     const startIndex = currentPage * 10;
//   //     const pageOrders = filteredOrders.slice(startIndex, startIndex + 10);

//   //     // Format
//   //     const formatted = pageOrders.map(order => ({
//   //       orderId: order.orderId,
//   //       orderDateAndTime: order.orderDateAndTime,
//   //       orderType: order.orderType?.replace(/[_-]/g, "") ?? "N/A",
//   //       paymentMethod: order.paymentMethod?.replace(/[_-]/g, "") ?? "N/A",
//   //       status: order.status,
//   //       grandTotal: order.grandTotal ?? 0,
//   //       userName: order.userName ? order.userName.trim() : "Guest",
//   //     }));

//   //     setStatusOrders(formatted);
//   //     setTotalPages(totalPages);

//   //   } catch (error) {
//   //     console.error("Search error:", error);
//   //     setStatusOrders([]);
//   //     setTotalPages(1);
//   //   } finally {
//   //     setIsLoadingStatus(false);
//   //   }
//   // };
//   // In Standardorder.jsx, update the handleSearch function:
//   const handleSearch = async (searchType = "orderId") => {
//     if (!vendorId) return;

//     // If search is empty, fetch normal orders
//     if (searchQuery.trim() === '') {
//       fetchPaginatedOrders(0);
//       return;
//     }

//     setIsLoadingStatus(true);
//     const token = localStorage.getItem("authToken");

//     try {
//       let filteredOrders = [];
//       let allOrders = [];

//       // DIFFERENT API FOR ORDER ID SEARCH
//       if (searchType === 'orderId') {
//         try {
//           // Use the specific order ID API
//           const response = await axios.get(
//             `https://backend.maamaas.com/food/api/orders/order/${searchQuery.trim()}`,
//             { headers: { Authorization: `Bearer ${token}` } }
//           );

//           // The API returns a single order object
//           const order = response.data;
//           if (order) {
//             // Convert single order to array for consistency
//             filteredOrders = [order];
//           } else {
//             filteredOrders = [];
//           }
//         } catch (error) {
//           console.error("Error fetching order by ID:", error);
//           filteredOrders = [];
//         }
//       } else {
//         // FOR OTHER SEARCH TYPES: Use the vendor orders API
//         const response = await axios.get(
//           `https://backend.maamaas.com/food/api/orders/vendor/${vendorId}`,
//           { headers: { Authorization: `Bearer ${token}` } }
//         );

//         allOrders = response.data || [];

//         // Apply date filter
//         if (selectedDate) {
//           allOrders = allOrders.filter(order => {
//             const orderDate = new Date(order.orderDateAndTime)
//               .toISOString()
//               .split("T")[0];
//             return orderDate === selectedDate;
//           });
//         }

//         // Apply search filter based on search type
//         const query = searchQuery.toLowerCase().trim();
//         filteredOrders = allOrders.filter(order => {
//           switch (searchType) {
//             case 'userName':
//               return order.userName?.toLowerCase().includes(query);
//             case 'orderType':
//               return order.orderType?.toLowerCase().includes(query);
//             case 'paymentMethod':
//               return order.paymentMethod?.toLowerCase().includes(query);
//             case 'status':
//               return order.status?.toLowerCase().includes(query);
//             default:
//               // For safety, include all fields
//               const orderIdMatch = order.orderId?.toString().toLowerCase().includes(query);
//               const userNameMatch = order.userName?.toLowerCase().includes(query);
//               const orderTypeMatch = order.orderType?.toLowerCase().includes(query);
//               const paymentMethodMatch = order.paymentMethod?.toLowerCase().includes(query);
//               const statusMatch = order.status?.toLowerCase().includes(query);
//               return orderIdMatch || userNameMatch || orderTypeMatch || paymentMethodMatch || statusMatch;
//           }
//         });
//       }

//       // Sort and paginate
//       filteredOrders.sort((a, b) => new Date(b.orderDateAndTime) - new Date(a.orderDateAndTime));

//       const totalElements = filteredOrders.length;
//       const totalPages = Math.max(1, Math.ceil(totalElements / 10));

//       const startIndex = currentPage * 10;
//       const pageOrders = filteredOrders.slice(startIndex, startIndex + 10);

//       // Format
//       const formatted = pageOrders.map(order => ({
//         orderId: order.orderId,
//         orderDateAndTime: order.orderDateAndTime || order.createdAt,
//         orderType: order.orderType?.replace(/[_-]/g, "") ?? "N/A",
//         paymentMethod: order.paymentMethod?.replace(/[_-]/g, "") ?? "N/A",
//         status: order.status,
//         grandTotal: order.grandTotal ?? 0,
//         userName: order.userName ? order.userName.trim() : "Guest",
//       }));

//       setStatusOrders(formatted);
//       setTotalPages(totalPages);

//     } catch (error) {
//       console.error("Search error:", error);
//       setStatusOrders([]);
//       setTotalPages(1);
//     } finally {
//       setIsLoadingStatus(false);
//     }
//   };

//   const fetchOrders = async () => {
//     if (!vendorId) return;

//     const token = localStorage.getItem("authToken");

//     try {
//       // Fetch ALL active orders
//       const response = await axios.get(
//         `https://backend.maamaas.com/food/api/orders/status-range`,
//         {
//           params: {
//             vendorId: vendorId,
//             fromStatus: "CONFIRMED",
//             toStatus: "WAITING_FOR_PICKUP",
//           },
//           headers: { Authorization: `Bearer ${token}` },
//         }
//       );

//       let allOrders = response.data || [];

//       // 🔥 REMOVED FILTER: Keep all orders regardless of userId
//       // allOrders = allOrders.filter(order => order.userId !== null && order.userId !== undefined);


//       // Also fetch dine-in orders for relevant statuses
//       const dineInStatuses = ["PROCESSING", "BEING_PREPARED", "ORDER_IS_READY", "WAITING_FOR_PICKUP"];
//       const dineInPromises = dineInStatuses.map(status =>
//         axios.get(
//           `https://backend.maamaas.com/food/api/cart/get/ordertype=TABLE_DINE_IN/${vendorId}/${status}`,
//           { headers: { Authorization: `Bearer ${token}` } }
//         )
//       );

//       const dineInResponses = await Promise.all(dineInPromises);
//       let dineInOrders = dineInResponses.flatMap(res => res.data || []);

//       // 🔥 REMOVED FILTER DINE-IN: Keep all dine-in orders regardless of userId
//       // dineInOrders = dineInOrders.filter(order => order.userId !== null && order.userId !== undefined);

//       // Filter TABLE_DINE_IN orders by cartItems status
//       dineInOrders = dineInOrders.filter(order =>
//         Array.isArray(order.cartItems) &&
//         order.cartItems.some(item =>
//           ["PROCESSING", "BEING_PREPARED", "ORDER_IS_READY", "WAITING_FOR_PICKUP"].includes(item.orderStatus)
//         )
//       );

//       // Combine and deduplicate
//       const combinedOrders = [...allOrders, ...dineInOrders];
//       const uniqueOrders = combinedOrders.filter(
//         (order, index, self) =>
//           index === self.findIndex(
//             o => (o.cartId && o.cartId === order.cartId) || (o.orderId && o.orderId === order.orderId)
//           )
//       );

//       // Sort orders by date in ASCENDING order (oldest first)
//       const sortedOrders = uniqueOrders.sort((a, b) => {
//         const dateA = new Date(a.orderDateAndTime || a.cartDateAndTime || 0);
//         const dateB = new Date(b.orderDateAndTime || b.cartDateAndTime || 0);
//         return dateA - dateB; // For ascending order (oldest first)
//       });

//       setOrders(sortedOrders);

//     } catch (error) {
//       console.error("❌ Failed to fetch orders:", error.response?.data || error.message);
//     }
//   };

//   // 2. Helper to get selected dine-in items
//   const getSelectedDineInItems = (order) => {
//     if (!order.cartItems || order.orderType !== "TABLE_DINE_IN") return [];

//     // Get selected items from selectedItems state
//     const orderId = order.orderId || order.cartId;
//     const selectedIndexes = selectedItems[orderId] || [];

//     return order.cartItems.filter((item, index) =>
//       selectedIndexes.includes(index)
//     );
//   };

//   // 3. Function to get selected dine-in item IDs
//   const getSelectedDineInItemIds = (order) => {
//     const selectedItemsList = getSelectedDineInItems(order);
//     return selectedItemsList.map(item => item.itemId).filter(id => id);
//   };

//   // 4. Helper to get current stage index
//   const getCurrentStageIndex = (order) => {
//     const stageOrder = ["Placed", "Preparing", "Prepared", "Dispatched", "Delivered"];
//     const statusToStage = {
//       CONFIRMED: "Placed",
//       PROCESSING: "Preparing",      // ← CHANGE from "Placed" to "Preparing"
//       ORDER_IS_READY: "Prepared",   // Keep
//       WAITING_FOR_PICKUP: "Dispatched", // Keep
//       DELIVERED: "Delivered"        // ← CHANGE from COMPLETED to DELIVERED
//     };

//     if (order.orderType === "TABLE_DINE_IN" && Array.isArray(order.cartItems)) {
//       // For dine-in, find the highest completed stage among ALL items
//       const itemStatuses = order.cartItems.map(item => item.orderStatus);
//       let highestStageIndex = 0;

//       itemStatuses.forEach(status => {
//         const stage = statusToStage[status] || "Placed";
//         const stageIndex = stageOrder.indexOf(stage);
//         if (stageIndex > highestStageIndex) {
//           highestStageIndex = stageIndex;
//         }
//       });

//       return highestStageIndex;
//     } else {
//       // For normal orders
//       const currentStage = statusToStage[order.status] || "Placed";
//       return stageOrder.indexOf(currentStage);
//     }
//   };

//   // 5. Function to update normal order status
//   const updateOrderStatus = async (orderId, newStatus) => {
//     const token = localStorage.getItem("authToken");
//     if (!token) {
//       alert("Authentication token missing");
//       return false;
//     }

//     try {
//       // Map UI status to API status values
//       const statusMap = {
//         "Preparing": "PROCESSING",        // ← CHANGE to PROCESSING
//         "Prepared": "ORDER_IS_READY",     // Keep (correct)
//         "Dispatched": "WAITING_FOR_PICKUP", // Keep (correct)
//         "Delivered": "DELIVERED"          // ← CHANGE to DELIVERED
//       };


//       const apiStatus = statusMap[newStatus];

//       const response = await axios.put(
//         `https://backend.maamaas.com/food/api/orders/edit-orders/${orderId}/${apiStatus}`,
//         { status: apiStatus },
//         { headers: { Authorization: `Bearer ${token}` } }
//       );

//       return true;
//     } catch (error) {
//       console.error(`Failed to update order status to ${newStatus}:`, error);
//       alert(`Failed to update status: ${error.response?.data?.message || error.message}`);
//       return false;
//     }
//   };

//   // 6. Function to update TABLE_DINE_IN cart items status
//   const updateDineInItemsStatus = async (cartId, itemIds, newStatus) => {
//     const token = localStorage.getItem("authToken");
//     if (!token) {
//       alert("Authentication token missing");
//       return false;
//     }

//     try {
//       // Map UI status to API status values for dine-in
//       const statusMap = {
//         "Preparing": "PROCESSING",        // ← CHANGE to PROCESSING
//         "Prepared": "ORDER_IS_READY",     // Keep (correct)
//         "Dispatched": "WAITING_FOR_PICKUP", // Keep (correct)
//         "Delivered": "DELIVERED"          // ← CHANGE to DELIVERED
//       };


//       const apiStatus = statusMap[newStatus];
//       const note = "Updated from order lifecycle";

//       if (itemIds.length === 0) {
//         alert("No items selected");
//         return false;
//       }

//       // Join itemIds for batch update
//       const itemIdsParam = itemIds.join("&itemIds=");
//       const url = `https://backend.maamaas.com/food/api/cart/cart/status/${cartId}?itemIds=${itemIdsParam}&status=${apiStatus}&note=${encodeURIComponent(note)}`;

//       const response = await fetch(url, {
//         method: "PUT",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${token}`,
//         },
//       });

//       if (!response.ok) {
//         const errorText = await response.text();
//         throw new Error(`Error ${response.status}: ${errorText}`);
//       }

//       const data = await response.json();
//       return true;
//     } catch (error) {
//       console.error(`Failed to update dine-in items status to ${newStatus}:`, error);
//       alert(`Failed to update dine-in items: ${error.message}`);
//       return false;
//     }
//   };

//   // 7. Function to handle stage click
//   // 7. Function to handle stage click - MODIFIED VERSION
//   const handleStageClick = async (order, stage, stageIndex) => {
//     const orderId = order.orderId || order.cartId;

//     // Don't allow clicking on already completed stages
//     const stageOrder = ["Placed", "Preparing", "Prepared", "Dispatched", "Delivered"];
//     const currentStageIndex = getCurrentStageIndex(order);

//     // PREVENT GOING BACK: Check if stage is already completed
//     if (stageIndex <= currentStageIndex) {
//       return; // Already completed or current stage, no action
//     }

//     // ✅ REMOVED: The check for sequential progression
//     // if (stageIndex !== currentStageIndex + 1) {
//     //   const nextStage = stageOrder[currentStageIndex + 1];
//     //   alert(`Please complete "${nextStage}" stage first!`);
//     //   return;
//     // }

//     // Show confirmation
//     // const confirmMessage = order.orderType === "TABLE_DINE_IN"
//     //   ? `Mark ${getSelectedDineInItemIds(order).length} selected items as "${stage}"?`
//     //   : `Mark order #${orderId} as "${stage}"?`;

//     // if (!window.confirm(confirmMessage)) {
//     //   return;
//     // }

//     let success = false;

//     // For TABLE_DINE_IN orders with selected items
//     if (order.orderType === "TABLE_DINE_IN") {
//       const selectedItemIds = getSelectedDineInItemIds(order);
//       if (selectedItemIds.length === 0) {
//         alert("Please select at least one item to update");
//         return;
//       }

//       success = await updateDineInItemsStatus(order.cartId, selectedItemIds, stage);
//     } else {
//       // For normal orders
//       success = await updateOrderStatus(orderId, stage);
//     }

//     if (success) {
//       // Refresh orders after short delay
//       setTimeout(() => {
//         fetchOrders();
//       }, 500);
//     }
//   };
//   // Separate function to export ALL orders
//   const exportAllOrdersForCSV = async () => {
//     if (!vendorId) {
//       alert("No vendor ID found");
//       return;
//     }

//     showLoader();
//     try {
//       const token = localStorage.getItem("authToken");

//       // Fetch ALL orders for export (not paginated)
//       const response = await axios.get(
//         `https://backend.maamaas.com/food/api/orders/vendor/${vendorId}`,
//         { headers: { Authorization: `Bearer ${token}` } }
//       );

//       let allOrders = response.data || [];

//       // Apply date filter if selected
//       if (selectedDate) {
//         allOrders = allOrders.filter(order => {
//           if (!order.orderDateAndTime) return false;
//           const orderDate = new Date(order.orderDateAndTime).toISOString().split('T')[0];
//           return orderDate === selectedDate;
//         });
//       }

//       if (allOrders.length === 0) {
//         alert("No data to export!");
//         hideLoader();
//         return;
//       }

//       // Build CSV with username column
//       const headers = ["S.No", "Order ID", "User Name", "Date", "Category", "Type", "Payment", "Order Status", "Amount"];

//       const rows = allOrders.map((item, index) => [
//         index + 1,
//         item.orderId,
//         item.userName || "Guest", // Add username here
//         new Date(item.orderDateAndTime).toLocaleDateString("en-GB"),
//         "Food",
//         item.orderType || item.orderService,
//         item.paymentMethod === "Online_Payment" ? "Online" : item.paymentMethod,
//         item.status,
//         Math.round(item.grandTotal || 0),
//       ]);

//       // Format CSV for Excel compatibility
//       const formatCell = (cell) => {
//         if (cell === null || cell === undefined) return '""';
//         const cellStr = String(cell);

//         // Escape double quotes by doubling them
//         const escaped = cellStr.replace(/"/g, '""');

//         // Wrap in quotes if contains comma, quotes, or newline
//         if (cellStr.includes(',') || cellStr.includes('"') || cellStr.includes('\n') || cellStr.includes('\r')) {
//           return `"${escaped}"`;
//         }
//         return escaped;
//       };

//       // Create CSV lines
//       const csvLines = [headers, ...rows]
//         .map(row => row.map(cell => formatCell(cell)).join(','));

//       // Add BOM (Byte Order Mark) for UTF-8 Excel compatibility
//       const BOM = '\uFEFF';
//       const csvContent = BOM + csvLines.join('\r\n'); // Use \r\n for Windows compatibility

//       // Create blob with proper MIME type
//       const blob = new Blob([csvContent], {
//         type: 'text/csv; charset=utf-8;'
//       });

//       // Create download link
//       const url = URL.createObjectURL(blob);
//       const link = document.createElement('a');

//       // Use .csv extension but format it for Excel
//       const fileName = `Orders_${selectedDate || 'All'}_${new Date().toISOString().split('T')[0]}.csv`;

//       link.href = url;
//       link.setAttribute('download', fileName);
//       link.style.visibility = 'hidden';

//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);

//       // Clean up
//       setTimeout(() => URL.revokeObjectURL(url), 100);

//       // Optional: Show success message

//     } catch (error) {
//       console.error("Export error:", error);
//       alert("Failed to export data. Please try again.");
//     } finally {
//       hideLoader();
//     }
//   };
//   const [showDetails, setShowDetails] = useState(false);

//   const orderStages = ["Placed", "Preparing", "Prepared", "Dispatched", "Delivered"];

//   const styles = {
//     card: { border: '1px solid #ccc', padding: '16px', margin: '16px', marginRight: "0px", marginLeft: "0px", borderRadius: '10px', background: "linear-gradient(to right, #f46b45, #eea849)", },
//     header: { display: 'flex', justifyContent: 'space-around', },
//     orderId: { margin: 0, fontWeight: "bold" },
//     date: { fontSize: '18px', color: '#000', fontWeight: "bold" },
//     pickupBtn: { background: '#28a745', color: '#fff', border: 'none', padding: '6px 12px', cursor: 'pointer', borderRadius: '5px', fontWeight: "bold", },
//     tracker: { marginTop: '10px', display: 'flex', alignItems: 'center', fontWeight: "bold" },
//     statusBox: { background: '#eee', padding: '8px 12px', borderRadius: '5px' },
//     arrow: { margin: '0 5px' },
//     dropdownBtn: {
//       background: 'none',
//       border: 'none',
//       fontSize: '20px',
//       cursor: 'pointer',
//       ...(screenWidth >= 1000 && screenWidth <= 1200 ? { marginLeft: '100px' } : {}), // 👈 conditional style
//     },
//     itemList: { marginTop: '10px', fontWeight: "bold" },
//     itemRow: { display: 'flex', justifyContent: 'space-between', padding: '4px 0', borderBottom: '1px solid #ddd' }
//   };
//   // Helper function to get status color
//   const getStatusColor = (status) => {
//     const statusColors = {
//       CONFIRMED: '#607d8b',          // Orange
//       PROCESSING: '#607d8b',         // Blue
//       BEING_PREPARED: '#607d8b',     // Green
//       ORDER_IS_READY: '#607d8b',     // Purple
//       WAITING_FOR_PICKUP: '#607d8b', // Gray
//       COMPLETED: '#607d8b',          // Brown
//     };
//     return statusColors[status] || '#666';
//   };

//   // Helper function to get status text
//   const getStatusText = (status) => {
//     const statusTexts = {
//       CONFIRMED: "Confirmed",
//       PROCESSING: "Placed",
//       BEING_PREPARED: "Preparing",
//       ORDER_IS_READY: "Prepared",
//       WAITING_FOR_PICKUP: "Dispatched",
//       COMPLETED: "Delivered",
//     };
//     return statusTexts[status] || "Processing";
//   };


//   // Function to fetch order details for receipt


//   const [printOrderData, setPrintOrderData] = useState({});

//   // Add this function near your other functions (like fetchPaginatedOrders)
//   const handlePrintReceipt = async (order) => {
//     setIsPrinting(true);
//     setPrintingOrderId(order.orderId);

//     try {
//       const token = localStorage.getItem("authToken");

//       // Fetch order details - try both endpoints
//       let orderDetails = null;

//       try {
//         // Try the same endpoint as your cart file
//         const response = await axios.get(
//           `https://backend.maamaas.com/food/api/orders/order/${order.orderId}`,
//           { headers: { Authorization: `Bearer ${token}` } }
//         );
//         orderDetails = response.data;
//       } catch (err1) {
//         try {
//           const response = await axios.get(
//             `https://backend.maamaas.com/food/api/orders/get/${order.orderId}`,
//             { headers: { Authorization: `Bearer ${token}` } }
//           );
//           orderDetails = response.data;
//         } catch (err2) {
//           console.error("Both endpoints failed:", err1, err2);
//           throw new Error("Could not fetch order details");
//         }
//       }

//       // Set print order data
//       setPrintOrderData(orderDetails);

//       // Create receipt HTML using YOUR EXACT handlePrint logic
//       const printStyles = `
// <style>
// @media print {
//     body {
//         width: 80mm !important;
//         margin: 0 auto !important;
//         padding: 0 !important;
//         font-family: "Courier New", monospace !important;
//         font-size: 12px !important;
//         line-height: 1.25 !important;
//         font-weight: 700 !important;
//     }

//     h1, h2, h3 {
//         font-weight: 800;
//         text-align: center;
//         margin: 0;
//         padding: 0;
//         font-size: 16px !important;
//     }

//     .big-title {
//         font-size: 16px !important;
//         font-weight: 800;
//         text-align: center;
//         margin-bottom: 6px;
//     }

//     .center-text {
//         text-align: center;
//         font-size: 12px !important;
//         font-weight: 700;
//     }

//     .line {
//         border-top: 1px solid black;
//         margin: 7px 0;
//     }

//     .dashed {
//         border-top: 1px dashed black;
//         margin: 7px 0;
//     }

//     table {
//         width: 100%;
//         font-size: 12px !important;
//         border-collapse: collapse;
//     }

//     th {
//         padding: 2px 0px;
//         font-weight: 800;
//         font-size: 12px !important;
//     }

//     td {
//         padding: 3px 0px;
//         font-weight: 600;
//         font-size: 12px !important;
//     }

//     .row {
//         display: flex;
//         justify-content: space-around;
//         font-size: 12px !important;
//         font-weight: 700;
//         white-space: nowrap;
//         width: 100%;
//     }

//     .grand-label,
//     .grand-value {
//         font-size: 18px !important;
//         font-weight: 800;
//     }

//     .footer {
//         text-align: center;
//         margin-top: 12px;
//         font-size: 12px !important;
//         font-weight: 700;
//     }

//     .receipt-buttons, button {
//         display: none !important;
//     }

//     @page {
//         size: 80mm auto;
//         margin: 0;
//     }

//     .page-break {
//         page-break-after: always;
//     }
// }
// </style>
// `;

//       // Get vendor details for GSTIN/FSSAI
//       const vendorId = localStorage.getItem("vendorId");
//       let vendorGstIn = "N/A";
//       let vendorFssai = "23624032003384";

//       try {
//         const vendorResponse = await axios.get(
//           `https://backend.maamaas.com/food/api/vendors/${vendorId}`,
//           { headers: { Authorization: `Bearer ${token}` } }
//         );
//         vendorGstIn = vendorResponse.data?.gstNumber || "N/A";
//         vendorFssai = vendorResponse.data?.fssaiNumber || "23624032003384";
//       } catch (vendorErr) {
//       }

//       // Format date and time
//       const formatDate = (dateString) => {
//         try {
//           const date = new Date(dateString);
//           return date.toLocaleDateString('en-GB');
//         } catch {
//           return new Date().toLocaleDateString('en-GB');
//         }
//       };

//       const formatTime = (dateString) => {
//         try {
//           const date = new Date(dateString);
//           return date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true });
//         } catch {
//           return new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true });
//         }
//       };

//       // SIMPLE RECEIPT (Top Image) - HARDCODED "Take A Break" - SAME AS YOUR CART
//       const receiptOne = `
//         <div class="big-title">Take A Break</div>
//         <div class="line"></div>

//         <div class="row"><span>OrderID: ${orderDetails.orderId}</span><span>Date: ${orderDetails.date || formatDate(orderDetails.orderDateAndTime)}</span></div>
//         <div class="row"><span>Type: ${orderDetails.orderType || "Dine In"}</span><span>Time: ${orderDetails.time || formatTime(orderDetails.orderDateAndTime)}</span></div>

//         <div class="center-text">Payment: ${orderDetails.paymentMethod || "Cash"}</div>

//         <div class="line"></div>

//         <table>
//             <thead>
//                 <tr>
//                     <th style="text-align:center;">Item</th>
//                     <th style="text-align:center;">Qty</th>
//                 </tr>
//             </thead>
//             <tbody>
//                 ${Array.isArray(orderDetails.order) ? orderDetails.order.map(item => `
//                     <tr>
//                         <td style="text-align:center;">${item.dishName || "Item"}</td>
//                         <td style="text-align:center;">${item.quantity || 1}</td>
//                     </tr>
//                 `).join("") : ""}
//             </tbody>
//         </table>

//         <div class="line"></div>
//     `;

//       // DETAILED RECEIPT (Bottom Image) - HARDCODED "Take A Break" - SAME AS YOUR CART
//       const receiptTwo = `
//         <div class="big-title">Take A Break</div>
//         <div class="center-text">GSTIN: ${vendorGstIn}</div>
//         <div class="line"></div>

//         <div class="row"><span>OrderID: ${orderDetails.orderId}</span><span>Date: ${orderDetails.date || formatDate(orderDetails.orderDateAndTime)}</span></div>
//         <div class="row"><span>Type: ${orderDetails.orderType || "Dine In"}</span><span>Time: ${orderDetails.time || formatTime(orderDetails.orderDateAndTime)}</span></div>
//         <div class="center-text">Payment: ${orderDetails.paymentMethod || "Cash"}</div>

//         <div class="line"></div>

//         <table class="items-table">
//             <thead>
//                 <tr>
//                     <th style="text-align:center;">Item</th>
//                     <th style="text-align:center;">Qty</th>
//                     <th style="text-align:center;">Price</th>
//                     <th style="text-align:center;">Total</th>
//                 </tr>
//             </thead>
//             <tbody>
//     ${Array.isArray(orderDetails.order) ? orderDetails.order.map(item => `
//         <tr>
//             <td style="text-align:center;"><b>${item.dishName || "Item"}</b></td>
//             <td style="text-align:center;"><b>${item.quantity || 1}</b></td>
//             <td style="text-align:center;"><b>₹${(item.price || 0).toFixed(2)}</b></td>
//             <td style="text-align:center;"><b>₹${((item.price || 0) * (item.quantity || 1)).toFixed(2)}</b></td>
//         </tr>
//     `).join("") : ""}
// </tbody>

//         </table>

//         <div class="line"></div>

//         <div class="row"><span>SubTotal</span><span>₹${(orderDetails.subTotal || 0).toFixed(2)}</span></div>
//         <div class="row"><span>Platform</span><span>₹${(orderDetails.platformCharges || 0).toFixed(2)}</span></div>
//         <div class="row"><span>Service</span><span>₹${(orderDetails.serviceCharge || 0).toFixed(2)}</span></div>
//         <div class="row"><span>CGST</span><span>₹${(orderDetails.cgst || 0).toFixed(2)}</span></div>
//         <div class="row"><span>SGST</span><span>₹${(orderDetails.sgst || 0).toFixed(2)}</span></div>

//         <div class="line"></div>

//         <div class="row">
//             <span class="grand-label">Grand Total</span>
//             <span class="grand-value">₹${(orderDetails.grandTotal || 0).toFixed(2)}</span>
//         </div>

//         <div class="dashed"></div>
//         <div class="center-text">FSSAI: ${vendorFssai}</div>

//         <div class="footer">
//             Thank you, visit again<br/>
//             www.maamaas.com
//         </div>
//     `;

//       // FINAL PRINT CONTENT - SAME FORMAT AS YOUR CART
//       const finalHTML = `
//         <!DOCTYPE html>
//         <html>
//         <head>
//             <title>Receipt - ${orderDetails.orderId || 'Order'}</title>
//             ${printStyles}
//         </head>
//         <body>
//             ${receiptOne}
//             <div class="page-break"></div>
//             ${receiptTwo}
//         </body>
//         </html>
//     `;

//       // Open print window - SAME LOGIC AS YOUR CART
//       const printWindow = window.open('', '_blank', 'width=800,height=600');

//       if (!printWindow) {
//         alert("Please allow pop-ups to print receipt");
//         throw new Error("Popup blocked");
//       }

//       printWindow.document.open();
//       printWindow.document.write(finalHTML);
//       printWindow.document.close();

//       printWindow.onload = () => {
//         printWindow.print();

//         // Listen for afterprint event
//         printWindow.onafterprint = () => {
//           setTimeout(() => {
//             printWindow.close();
//           }, 500);
//         };

//         // Fallback in case afterprint doesn't fire
//         setTimeout(() => {
//           if (printWindow && !printWindow.closed) {
//             printWindow.close();
//           }
//         }, 3000);
//       };

//       setTimeout(() => {
//         if (printWindow && !printWindow.closed) {
//           printWindow.close();
//         }
//       }, 1000);

//     } catch (error) {
//       console.error("Print error:", error);

//       if (error.message.includes("Popup blocked")) {
//         alert("Please allow pop-ups in your browser to print receipts.");
//       } else {
//         alert("Failed to print receipt. Error: " + error.message);
//       }
//     } finally {
//       setIsPrinting(false);
//       setPrintingOrderId(null);
//     }
//   };

//   // Helper function to get status text - UPDATE THIS FUNCTION
//   const getStatusTextt = (status) => {
//     const statusTexts = {
//       CONFIRMED: "Placed",
//       PROCESSING: "Preparing",
//       BEING_PREPARED: "Preparing", // Map to same as PROCESSING
//       ORDER_IS_READY: "Prepared",
//       WAITING_FOR_PICKUP: "Dispatched",
//       DELIVERED: "Delivered",
//       COMPLETED: "Delivered", // Map to same as DELIVERED
//       PENDING: "Placed",
//       ACCEPTED: "Placed",
//       REJECTED: "Cancelled",
//       CANCELLED: "Cancelled",
//     };
//     return statusTexts[status] || status;
//   };

//   // Helper function to get status color - UPDATE THIS TOO
//   const getStatusColorr = (status) => {
//     const statusColors = {
//       CONFIRMED: '#607d8b',          // Gray - Placed
//       PROCESSING: '#2196F3',         // Blue - Preparing
//       BEING_PREPARED: '#2196F3',     // Blue - Preparing
//       ORDER_IS_READY: '#9C27B0',     // Purple - Prepared
//       WAITING_FOR_PICKUP: '#FF9800', // Orange - Dispatched
//       DELIVERED: '#4CAF50',          // Green - Delivered
//       COMPLETED: '#4CAF50',          // Green - Delivered
//       PENDING: '#607d8b',            // Gray - Placed
//       ACCEPTED: '#607d8b',           // Gray - Placed
//       REJECTED: '#f44336',           // Red - Cancelled
//       CANCELLED: '#f44336',          // Red - Cancelled
//     };
//     return statusColors[status] || '#666';
//   };
//   useEffect(() => {
//     // Reset to first page when search query changes
//     setCurrentPage(0);
//   }, [searchQuery]);

//   // Helper function to format schedule date and time
//   const formatScheduleDateTime = (order) => {
//     if (!order.date || !order.time) return "N/A";

//     try {
//       // Format date
//       const dateObj = new Date(order.date);
//       const formattedDate = dateObj.toLocaleDateString('en-IN', {
//         day: '2-digit',
//         month: 'short',
//         year: 'numeric',
//       });

//       // Format time
//       const formattedTime = formatTime(order.time);

//       return `${formattedDate} ${formattedTime}`;
//     } catch (e) {
//       console.error("Error formatting schedule date/time:", e);
//       return "N/A";
//     }
//   };

//   // Helper function to format time (if not already present)
//   const formatTime = (timeString) => {
//     if (!timeString) return "N/A";
//     try {
//       if (timeString.includes(':')) {
//         const [hours, minutes] = timeString.split(':');
//         const hour = parseInt(hours);
//         const ampm = hour >= 12 ? 'PM' : 'AM';
//         const displayHour = hour % 12 || 12;
//         return `${displayHour}:${minutes} ${ampm}`;
//       }
//       return timeString;
//     } catch (e) {
//       return timeString;
//     }
//   };

//   // {=======================overview===============================}
//   const tabContent = {
//     "Order Life-Cycle": (
//       <div style={{
//         overflow: 'auto',
//         scrollbarWidth: "thin",
//         msOverflowStyle: "none",
//         maxHeight: '70vh', // Adjust height as needed
//         WebkitOverflowScrolling: 'touch',
//         width: window.innerWidth < 769 ? "94vw" : window.innerWidth >= 769 && window.innerWidth < 992 ? "70vw" : " ",
//       }}>
//         {orders.map((order) => {
//           // For TABLE_DINE_IN orders, use cartItems; otherwise use orderItems
//           const orderItems = order.orderType === "TABLE_DINE_IN" ? order.cartItems || [] : order.order || [];
//           const orderId = order.orderId || order.cartId; // fallback for TABLE_DINE_IN
//           const selected = selectedItems[orderId] || [];

//           return (
//             // Replace the header section inside your order mapping
//             <div key={orderId} style={{
//               border: '1px solid #ccc',
//               padding: '10px',
//               margin: '16px',
//               marginRight: "0px",
//               borderRadius: '10px',
//               background: (() => {
//                 const normalized = (order.orderType || "").trim().toLowerCase();
//                 switch (normalized) {
//                   case "dine_in": return "#1E90FF";
//                   case "takeaway": return "#FF6347";
//                   case "delivery": return "#20B2AA";
//                   case "table_dine_in": return "#2051b2ff";
//                   default: return "#b15cd6";
//                 }
//               })(),
//             }}>
//               <div style={styles.header}>
//                 {/* Main container with responsive layout */}
//                 <div style={{
//                   display: 'flex',
//                   flexDirection: window.innerWidth < 1300 ? 'column' : 'row',
//                   justifyContent: 'space-between',
//                   alignItems: window.innerWidth < 1300 ? 'stretch' : 'center',
//                   gap: window.innerWidth < 1300 ? '10px' : '0',
//                   width: '100%',
//                   padding: '5px 0',

//                 }}>

//                   {/* First Line: Order ID and Date/Time - Full width with space-between */}
//                   <div style={{
//                     display: 'flex',
//                     justifyContent: 'space-between',
//                     alignItems: window.innerWidth <= 500 ? 'start' : 'center',
//                     width: '100%',
//                     flexDirection: window.innerWidth <= 500 ? "column" : "row",
//                     marginLeft: window.innerWidth <= 370 ? "-1rem" : " ",
//                     gap: window.innerWidth <= 370 ? '0px' : '10px',
//                     padding: window.innerWidth < 1300 ? '0 5px' : '0',
//                   }}>
//                     <div style={{
//                       ...styles.orderId,
//                       margin: 0,
//                       fontSize: window.innerWidth <= 370 ? '14px' : '17px',
//                       fontWeight: 'bold',
//                       color: "black",
//                       whiteSpace: 'nowrap',
//                       display: "flex",
//                       justifyContent: "space-between", // This pushes children to opposite ends
//                       alignItems: "center",
//                       width: "100%", // Ensure it takes full width
//                     }}>
//                       {/* Left side - Order ID */}
//                       <div style={{
//                         flex: "0 0 auto", // Don't grow, don't shrink, auto width
//                       }}>
//                         ORDER ID : <span style={{
//                           fontSize: window.innerWidth <= 500 ? "1rem" : "1.3rem",
//                           color: "white"
//                         }}>#{orderId}</span>
//                       </div>

//                       {/* Right side - Order Type button */}
//                       <div style={{
//                         flex: "0 0 auto", // Don't grow, don't shrink, auto width
//                         marginLeft: "10px", // Add some spacing from Order ID
//                       }}>
//                         <button style={{
//                           background: '#28a745',
//                           color: '#fff',
//                           border: 'none',
//                           padding: window.innerWidth < 1100 ? "5px 10px" : '6px 15px',
//                           borderRadius: '4px',
//                           fontWeight: 'bold',
//                           fontSize: '14px',
//                           whiteSpace: 'nowrap',
//                           cursor: 'default',
//                           display: window.innerWidth <= 450 ? "block" : "none",
//                         }}>
//                           {order.orderType === 'DINE_IN' ? 'DINEIN' : (order.service || order.orderType || 'Service')}
//                         </button>
//                       </div>
//                     </div>

//                     {/* Date and Time inline */}
//                     {order.orderDateAndTime && (
//                       <div style={{
//                         display: 'flex',
//                         alignItems: 'center',
//                         fontSize: window.innerWidth <= 370 ? '14px' : '16px',
//                         color: '#000000ff',
//                         fontWeight: '500',
//                         whiteSpace: 'nowrap',
//                       }}>
//                         <span style={{ whiteSpace: 'nowrap' }}>
//                           {(() => {
//                             const dateObj = new Date(order.orderDateAndTime);
//                             const date = dateObj.toLocaleDateString('en-IN', {
//                               day: '2-digit',
//                               month: 'short',
//                               year: 'numeric',
//                             });
//                             const time = dateObj.toLocaleTimeString('en-IN', {
//                               hour: '2-digit',
//                               minute: '2-digit',
//                               hour12: true,
//                             });
//                             return (
//                               <>
//                                 <span style={{ color: '#000000ff', fontWeight: 'bold', fontSize: window.innerWidth <= 370 ? '14px' : '17px', }}>DATE:</span>
//                                 <span style={{ color: '#ffffffff', marginRight: '10px', marginLeft: "5px", fontSize: window.innerWidth <= 500 ? "1rem" : "1.3rem" }}>{date}</span>
//                                 <span style={{ color: '#000000ff', fontWeight: 'bold', fontSize: window.innerWidth <= 370 ? '14px' : '17px', }}>TIME:</span>
//                                 <span style={{ color: '#ffffffff', marginLeft: "5px", fontSize: window.innerWidth <= 500 ? "1rem" : "1.3rem" }}>{time}</span>
//                               </>
//                             );
//                           })()}
//                         </span>
//                         <button
//                           style={{
//                             background: 'none',
//                             border: '0px solid #ccc',
//                             borderRadius: '4px',
//                             padding: '6px 12px',
//                             cursor: 'pointer',
//                             fontSize: '14px',
//                             minWidth: '40px',
//                             display: window.innerWidth > 1299 ? "none" : "block",
//                           }}
//                           onClick={() =>
//                             setShowDetails((prev) => ({
//                               ...prev,
//                               [orderId]: !prev[orderId],
//                             }))
//                           }
//                         >
//                           {showDetails[orderId] ? '▲' : '▼'}
//                         </button>
//                       </div>

//                     )}
//                   </div>

//                   {/* Second Line: Order Type, Status, and Dropdown - Aligned to end */}
//                   <div style={{
//                     display: 'flex',
//                     justifyContent: window.innerWidth < 1300 ? 'flex-end' : 'end',
//                     alignItems: 'center',
//                     gap: window.innerWidth >= 1300 && window.innerWidth < 1350 ? '5px' : '15px',
//                     width: '100%',
//                     padding: window.innerWidth < 1300 ? '5px 5px 0 5px' : '0',
//                     flexWrap: 'wrap',
//                   }}>
//                     {/* Order Type */}
//                     <div style={{
//                       display: 'flex',
//                       alignItems: 'center',
//                     }}>
//                       <button style={{
//                         background: '#28a745',
//                         color: '#fff',
//                         border: 'none',
//                         padding: window.innerWidth < 1100 ? "5px 10px" : '6px 15px',
//                         borderRadius: '4px',
//                         fontWeight: 'bold',
//                         fontSize: '14px',
//                         whiteSpace: 'nowrap',
//                         cursor: 'default',
//                         display: window.innerWidth > 450 ? "block" : "none",

//                       }}>
//                         {order.orderType === 'DINE_IN' ? 'DINEIN' : (order.service || order.orderType || 'Service')}
//                       </button>
//                     </div>

//                     {/* Status indicator */}
//                     <div style={{
//                       padding: '6px 12px',
//                       backgroundColor: getStatusColor(order.status),
//                       color: 'white',
//                       borderRadius: '4px',
//                       fontSize: '14px',
//                       textTransform: 'uppercase',
//                       whiteSpace: 'nowrap',
//                       minWidth: '100px',
//                       textAlign: 'center',
//                       display: window.innerWidth > 450 ? "block" : "none",
//                     }}>
//                       {getStatusText(order.status)}
//                     </div>

//                     {/* Dropdown button */}
//                     <button
//                       style={{
//                         background: 'none',
//                         border: '0px solid #ccc',
//                         borderRadius: '4px',
//                         padding: '6px 12px',
//                         cursor: 'pointer',
//                         fontSize: '14px',
//                         minWidth: '40px',
//                         display: window.innerWidth > 1299 ? "block" : "none",
//                       }}
//                       onClick={() =>
//                         setShowDetails((prev) => ({
//                           ...prev,
//                           [orderId]: !prev[orderId],
//                         }))
//                       }
//                     >
//                       {showDetails[orderId] ? '▲' : '▼'}
//                     </button>
//                   </div>
//                 </div>
//               </div>

//               {showDetails[orderId] && (
//                 <>
//                   <div style={{
//                     marginTop: window.innerWidth < 450 ? '-1rem' : '0rem',
//                     margin: window.innerWidth < 500 ? "0px 0%" : window.innerWidth >= 1200 ? " 0px 2%" : "0px 0%",
//                     paddingTop: '10px'
//                   }}>
//                     {/* Fixed height container for table scrolling */}
//                     <div style={{
//                       width: '100%',
//                       maxHeight: window.innerWidth <= 768 ? '350px' : 'auto',
//                       overflow: window.innerWidth <= 768 ? 'auto' : 'visible',
//                       overflowX: window.innerWidth <= 768 ? 'auto' : 'visible',
//                       overflowY: window.innerWidth <= 768 ? 'hidden' : 'visible',
//                       WebkitOverflowScrolling: 'touch',
//                       position: 'relative',
//                       scrollbarWidth: 'thin',
//                       msOverflowStyle: 'none',
//                       borderRadius: '8px',
//                       border: window.innerWidth <= 768 ? '2px solid #b15cd6' : 'none'
//                     }}>
//                       {/* Custom scrollbar styles */}
//                       <style>
//                         {`
//             /* Horizontal scrollbar only */
//             .table-scroll-container::-webkit-scrollbar {
//               height: 6px;
//               width: 6px;
//             }
//             .table-scroll-container::-webkit-scrollbar-track {
//               background: rgba(177, 92, 214, 0.1);
//               border-radius: 3px;
//               margin: 4px;
//             }
//             .table-scroll-container::-webkit-scrollbar-thumb {
//               background: #b15cd6;
//               border-radius: 3px;
//             }
//             .table-scroll-container::-webkit-scrollbar-thumb:hover {
//               background: #9a4bc2;
//             }
//             /* Hide vertical scrollbar */
//             .table-scroll-container::-webkit-scrollbar:vertical {
//               display: none;
//             }
//           `}
//                       </style>

//                       {/* Traditional Table */}
//                       <table style={{
//                         width: window.innerWidth <= 768 ? 'max-content' : '100%',
//                         minWidth: window.innerWidth <= 768 ? '650px' : '100%',
//                         borderCollapse: 'collapse',
//                         border: window.innerWidth <= 768 ? 'none' : '2px solid #b15cd6',
//                         background: 'transparent',
//                         borderRadius: window.innerWidth <= 768 ? '0' : '8px',
//                         overflow: 'hidden',
//                         boxShadow: window.innerWidth <= 768 ? 'none' : '0 4px 12px rgba(0, 0, 0, 0.1)'
//                       }}>
//                         {/* HEADER ROW */}
//                         <thead>
//                           <tr style={{
//                             background: '#b15cd6',
//                             borderBottom: '2px solid #9a4bc2',
//                             position: window.innerWidth <= 768 ? 'sticky' : 'static',
//                             top: 0,
//                             left: 0,
//                             zIndex: 10
//                           }}>
//                             <th style={{
//                               textAlign: 'center',
//                               color: 'Black',
//                               fontWeight: 'bold',
//                               fontSize: window.innerWidth <= 370 ? '12px' : window.innerWidth <= 768 ? '13px' : '14px',
//                               padding: window.innerWidth <= 768 ? '10px 8px' : '12px 8px',
//                               borderRight: '1px solid rgba(255, 255, 255, 0.3)',
//                               minWidth: '120px',
//                               position: 'sticky',
//                               left: 0,
//                               background: '#b15cd6',
//                               zIndex: 11
//                             }}>
//                               Name
//                             </th>
//                             <th style={{
//                               textAlign: 'center',
//                               color: 'Black',
//                               fontWeight: 'bold',
//                               fontSize: window.innerWidth <= 370 ? '12px' : window.innerWidth <= 768 ? '13px' : '14px',
//                               padding: window.innerWidth <= 768 ? '10px 8px' : '12px 8px',
//                               borderRight: '1px solid rgba(255, 255, 255, 0.3)',
//                               minWidth: '120px'
//                             }}>
//                               Mobile No.
//                             </th>

//                             {/* <th style={{
//                             textAlign: 'center',
//                             color: 'Black',
//                             fontWeight: 'bold',
//                             fontSize: window.innerWidth <= 370 ? '12px' : window.innerWidth <= 768 ? '13px' : '14px',
//                             padding: window.innerWidth <= 768 ? '10px 8px' : '12px 8px',
//                             borderRight: '1px solid rgba(255, 255, 255, 0.3)',
//                             minWidth: '140px'
//                           }}>
//                             Email
//                           </th> */}
//                             {order.sheduled === true && (
//                               <th style={{
//                                 textAlign: 'center',
//                                 color: 'Black',
//                                 fontWeight: 'bold',
//                                 fontSize: window.innerWidth <= 370 ? '12px' : window.innerWidth <= 768 ? '13px' : '14px',
//                                 padding: window.innerWidth <= 768 ? '10px 8px' : '12px 8px',
//                                 borderRight: '1px solid rgba(255, 255, 255, 0.3)',
//                                 minWidth: '140px'
//                               }}>
//                                 Schedule Time
//                               </th>
//                             )}

//                             <th style={{
//                               textAlign: 'center',
//                               color: 'Black',
//                               fontWeight: 'bold',
//                               fontSize: window.innerWidth <= 370 ? '12px' : window.innerWidth <= 768 ? '13px' : '14px',
//                               padding: window.innerWidth <= 768 ? '10px 8px' : '12px 8px',
//                               borderRight: '1px solid rgba(255, 255, 255, 0.3)',
//                               minWidth: '160px'
//                             }}>
//                               Item
//                             </th>
//                             <th style={{
//                               textAlign: 'center',
//                               color: 'Black',
//                               fontWeight: 'bold',
//                               fontSize: window.innerWidth <= 370 ? '12px' : window.innerWidth <= 768 ? '13px' : '14px',
//                               padding: window.innerWidth <= 768 ? '10px 8px' : '12px 8px',
//                               minWidth: '80px',
//                               position: 'sticky',
//                               right: 0,
//                               background: '#b15cd6',
//                               zIndex: 11
//                             }}>
//                               Qty
//                             </th>
//                           </tr>
//                         </thead>

//                         <tbody>
//                           {/* VALUES ROW */}
//                           <tr style={{
//                             borderBottom: '1px solid rgba(255, 255, 255, 0.2)'
//                           }}>
//                             <td style={{
//                               textAlign: 'center',
//                               padding: window.innerWidth <= 768 ? '12px 8px' : '15px 8px',
//                               borderRight: '1px solid rgba(255, 255, 255, 0.2)',
//                               fontSize: window.innerWidth <= 500 ? "0.9rem" : "1rem",
//                               color: '#ffffffff',
//                               fontWeight: '600',
//                               verticalAlign: 'middle',
//                               minWidth: '120px',
//                               position: 'sticky',
//                               left: 0,
//                               background: (() => {
//                                 const normalized = (order.orderType || "").trim().toLowerCase();
//                                 switch (normalized) {
//                                   case "dine_in": return "#1E90FF";
//                                   case "takeaway": return "#FF6347";
//                                   case "delivery": return "#20B2AA";
//                                   case "table_dine_in": return "#2051b2ff";
//                                   default: return "#b15cd6";
//                                 }
//                               })(),
//                               zIndex: 9
//                             }}>
//                               {order.deliveryUserName || order.userName || "Guest"}
//                             </td>
//                             <td style={{
//                               textAlign: 'center',
//                               padding: window.innerWidth <= 768 ? '12px 8px' : '15px 8px',
//                               borderRight: '1px solid rgba(255, 255, 255, 0.2)',
//                               fontSize: window.innerWidth <= 500 ? "0.9rem" : "1rem",
//                               color: '#ffffffff',
//                               fontWeight: '600',
//                               verticalAlign: 'middle',
//                               minWidth: '120px'
//                             }}>
//                               {order.mobileNo || "-"}
//                             </td>
//                             {/* <td style={{
//                             textAlign: 'center',
//                             padding: window.innerWidth <= 768 ? '12px 8px' : '15px 8px',
//                             borderRight: '1px solid rgba(255, 255, 255, 0.2)',
//                             fontSize: window.innerWidth <= 500 ? "0.85rem" : "0.95rem",
//                             color: '#ffffffff',
//                             fontWeight: '600',
//                             verticalAlign: 'middle',
//                             minWidth: '140px',
//                             wordBreak: 'break-all'
//                           }}>
//                             {order.email || "-"}
//                           </td> */}

//                             {/* ✅ ADD THIS: Schedule Time cell - only show if order.sheduled === true */}
//                             {order.sheduled === true && (
//                               <td style={{
//                                 textAlign: 'center',
//                                 padding: window.innerWidth <= 768 ? '12px 8px' : '15px 8px',
//                                 borderRight: '1px solid rgba(255, 255, 255, 0.2)',
//                                 fontSize: window.innerWidth <= 500 ? "0.85rem" : "0.95rem",
//                                 color: '#ffffffff',
//                                 fontWeight: '600',
//                                 verticalAlign: 'middle',
//                                 minWidth: '140px',
//                                 wordBreak: 'break-all'
//                               }}>
//                                 {formatScheduleDateTime(order)}
//                               </td>
//                             )}
//                             <td style={{
//                               textAlign: 'center',
//                               padding: window.innerWidth <= 768 ? '12px 8px' : '15px 8px',
//                               borderRight: '1px solid rgba(255, 255, 255, 0.2)',
//                               verticalAlign: 'middle',
//                               minWidth: '160px'
//                             }}>
//                               <div style={{
//                                 display: 'flex',
//                                 flexDirection: 'column',
//                                 alignItems: 'start',
//                                 gap: window.innerWidth <= 768 ? '8px' : '10px'
//                               }}>
//                                 {orderItems
//                                   .filter((item) => item.status === "Okay" || item.orderType === "TABLE_DINE_IN")
//                                   .map((item, index) => (
//                                     <div
//                                       key={index}
//                                       style={{
//                                         display: 'flex',
//                                         alignItems: 'center',
//                                         gap: window.innerWidth <= 768 ? '8px' : '10px',
//                                         justifyContent: 'center',
//                                         padding: '4px 0'
//                                       }}
//                                     >
//                                       <input
//                                         type="checkbox"
//                                         checked={!!selectedItems[item.listId || item.id || index]}
//                                         onChange={() => {
//                                           const id = item.listId || item.id || index;
//                                           setSelectedItems(prev => ({
//                                             ...prev,
//                                             [id]: !prev[id]
//                                           }));
//                                         }}
//                                         style={{
//                                           cursor: 'pointer',
//                                           width: window.innerWidth <= 768 ? '16px' : '18px',
//                                           height: window.innerWidth <= 768 ? '16px' : '18px',
//                                           accentColor: '#b15cd6',
//                                           flexShrink: 0
//                                         }}
//                                       />
//                                       <span style={{
//                                         fontSize: window.innerWidth <= 500 ? "0.8rem" : "0.9rem",
//                                         color: '#ffffffff',
//                                         fontWeight: '500',
//                                         whiteSpace: "nowrap",
//                                         overflow: 'hidden',
//                                         textOverflow: 'ellipsis',
//                                         maxWidth: window.innerWidth <= 768 ? '130px' : '150px'
//                                       }}>
//                                         {item.dishName}
//                                       </span>
//                                     </div>
//                                   ))}
//                               </div>
//                             </td>
//                             <td style={{
//                               textAlign: 'center',
//                               padding: window.innerWidth <= 768 ? '12px 8px' : '15px 8px',
//                               verticalAlign: 'middle',
//                               minWidth: '80px',
//                               position: 'sticky',
//                               right: 0,
//                               background: (() => {
//                                 const normalized = (order.orderType || "").trim().toLowerCase();
//                                 switch (normalized) {
//                                   case "dine_in": return "#1E90FF";
//                                   case "takeaway": return "#FF6347";
//                                   case "delivery": return "#20B2AA";
//                                   case "table_dine_in": return "#2051b2ff";
//                                   default: return "#b15cd6";
//                                 }
//                               })(),
//                               zIndex: 9
//                             }}>
//                               <div style={{
//                                 display: 'flex',
//                                 flexDirection: 'column',
//                                 alignItems: 'center',
//                                 gap: window.innerWidth <= 768 ? '8px' : '10px'
//                               }}>
//                                 {orderItems
//                                   .filter((item) => item.status === "Okay" || item.orderType === "TABLE_DINE_IN")
//                                   .map((item, index) => (
//                                     <div
//                                       key={index}
//                                       style={{
//                                         fontSize: window.innerWidth <= 500 ? "0.9rem" : "1rem",
//                                         color: '#ffffffff',
//                                         fontWeight: 'bold',
//                                         padding: '4px 0',
//                                         minWidth: '25px'
//                                       }}
//                                     >
//                                       {item.quantity || 1}
//                                     </div>
//                                   ))}
//                               </div>
//                             </td>
//                           </tr>

//                           {/* ADDRESS ROW */}
//                           <tr>
//                             <td colSpan={order.sheduled === true ? "5" : "4"} style={{ // ✅ Dynamic colspan
//                               padding: '0px',
//                               background: 'rgba(177, 92, 214, 0.1)',
//                               minWidth: window.innerWidth <= 768 ? '650px' : 'auto'
//                             }}>
//                               <div style={{
//                                 display: window.innerWidth < 500 ? 'flex' : 'grid',
//                                 gridTemplateColumns: window.innerWidth <= 768 ? '1fr' : 'auto 1fr',
//                                 alignItems: 'center',
//                                 gap: '0px',
//                                 width: '100%'
//                               }}>
//                                 <div style={{
//                                   fontSize: '17px',
//                                   color: 'black',
//                                   fontWeight: 'bold',
//                                   whiteSpace: 'nowrap',
//                                   padding: window.innerWidth <= 768 ? '10px 12px' : '8px 12px',
//                                   borderRadius: '4px',
//                                   border: '0px solid #b15cd6',
//                                   minWidth: window.innerWidth <= 768 ? '100px' : 'auto'
//                                 }}>
//                                   Address:
//                                 </div>
//                                 <div className='borderleft' style={{
//                                   fontSize: window.innerWidth <= 500 ? "0.95rem" : "1.05rem",
//                                   color: '#ffffffff',
//                                   fontWeight: '500',
//                                   wordBreak: 'break-word',
//                                   alignItems: "center",
//                                   display: "flex",
//                                   justifyContent: "center",
//                                   padding: window.innerWidth <= 768 ? '10px 15px' : '10px 15px',
//                                   borderRadius: '0px',
//                                   minWidth: window.innerWidth <= 768 ? '550px' : 'auto'
//                                 }}>
//                                   {order.deliveryAddress || "-"}
//                                 </div>
//                               </div>
//                             </td>
//                           </tr>
//                         </tbody>
//                       </table>
//                     </div>

//                   </div>
//                 </>
//               )}


//               <div style={{
//                 ...styles.tracker,
//                 display: 'flex',
//                 justifyContent: 'center',
//                 flexDirection: isMobile ? 'column' : 'row',
//                 gap: isMobile ? '5px' : '0px',
//                 alignItems: 'center',
//                 fontSize: window.innerWidth < 1300 ? "0.9rem" : "1rem",
//               }}>
//                 {orderStages.map((stage, index) => {
//                   const stageOrder = orderStages;

//                   // Get current stage index for this order
//                   const currentStageIndex = getCurrentStageIndex(order);

//                   // Determine if stage is completed
//                   const isCompleted = index <= currentStageIndex;

//                   // ✅ MODIFIED: Determine if stage is clickable (ANY future stage, not just next)
//                   const isFutureStage = index > currentStageIndex;
//                   const hasSelectedItems = order.orderType === "TABLE_DINE_IN"
//                     ? getSelectedDineInItemIds(order).length > 0
//                     : true;

//                   // 🔥 ADD THIS CHECK: If order type is DELIVERY and stage is "Delivered", disable it
//                   const isDeliveryAndDeliveredStage = (order.orderType === "DELIVERYY" && stage === "Deliveredd");

//                   // ✅ MODIFIED: Stage is clickable if: it's a future stage, has selected items (for dine-in), AND not delivery+delivered
//                   const isClickable = isFutureStage && hasSelectedItems && !isDeliveryAndDeliveredStage;

//                   return (
//                     <React.Fragment key={index}>
//                       <div
//                         onClick={() => isClickable && handleStageClick(order, stage, index)}
//                         style={{
//                           ...styles.statusBox,
//                           backgroundColor: isCompleted
//                             ? "green"
//                             : isClickable
//                               ? (index === currentStageIndex + 1 ? "#ffd900ff" : "#f0f0f0ff") // Immediate next is yellow, others are white
//                               : "#f0f0f0ff", // Not clickable also white
//                           color: isCompleted ? "white" : "black",
//                           borderRadius: "6px",
//                           padding: window.innerWidth < 1100 ? "6px 10px" : "8px 12px",
//                           fontWeight: "bold",
//                           textTransform: "uppercase",
//                           transition: "all 0.3s ease",
//                           cursor: isClickable ? "pointer" : "default",
//                           boxShadow: isClickable ? "0 2px 8px rgba(0,0,0,0.3)" : "none",
//                           position: "relative",
//                           transform: isClickable ? "translateY(-2px)" : "none",
//                           // Add visual indicator for skip-able stages
//                           border: isClickable ? (index > currentStageIndex + 1 ? "0px dashed #ff9800" : "0px solid #ff4081") : "2px solid transparent",
//                         }}
//                         onMouseEnter={(e) => {
//                           if (isClickable) {
//                             e.currentTarget.style.transform = "scale(1.05)";
//                             // Highlight skip-able stages differently
//                             if (index > currentStageIndex + 1) {
//                               e.currentTarget.style.boxShadow = "0 4px 12px rgba(255, 152, 0, 0.5)";
//                             }
//                           }
//                         }}
//                         onMouseLeave={(e) => {
//                           if (isClickable) {
//                             e.currentTarget.style.transform = "translateY(-2px)";
//                             if (index > currentStageIndex + 1) {
//                               e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.3)";
//                             }
//                           }
//                         }}
//                         title={isClickable
//                           ? `Click to mark as ${stage}${index > currentStageIndex + 1 ? " (Skip ahead)" : ""}`
//                           : isCompleted ? `Already ${stage}` : ""
//                         }
//                       >
//                         {stage}
//                         {/* {isClickable && index > currentStageIndex + 1 && (
//                           <span style={{
//                             position: "absolute",
//                             top: "-10px",
//                             right: "-10px",
//                             background: "#ff9800",
//                             color: "white",
//                             borderRadius: "50%",
//                             width: "20px",
//                             height: "20px",
//                             fontSize: "12px",
//                             display: "flex",
//                             alignItems: "center",
//                             justifyContent: "center",
//                             fontWeight: "bold",
//                             animation: "pulse 1.5s infinite",
//                           }}>
//                             ↗
//                           </span>
//                         )} */}
//                         {/* {isClickable && index === currentStageIndex + 1 && (
//                           <span style={{
//                             position: "absolute",
//                             top: "-8px",
//                             right: "-8px",
//                             background: "#ff4081",
//                             color: "white",
//                             borderRadius: "50%",
//                             width: "24px",
//                             height: "24px",
//                             fontSize: "14px",
//                             display: "flex",
//                             alignItems: "center",
//                             justifyContent: "center",
//                             fontWeight: "bold",
//                             animation: "pulse 2s infinite",
//                           }}>
//                             ●
//                           </span>
//                         )} */}
//                       </div>
//                       {index !== orderStages.length - 1 && <span style={styles.arrow}></span>}
//                     </React.Fragment>
//                   );
//                 })}
//                 {/* {orderStages.map((stage, index) => {
//                 const stageOrder = orderStages;

//                 // Get current stage index for this order
//                 const currentStageIndex = getCurrentStageIndex(order);

//                 // Determine if stage is completed
//                 const isCompleted = index <= currentStageIndex;

//                 // Determine if stage is clickable (next in sequence)
//                 const isNextStage = index === currentStageIndex + 1;
//                 const hasSelectedItems = order.orderType === "TABLE_DINE_IN"
//                   ? getSelectedDineInItemIds(order).length > 0
//                   : true;

//                 // 🔥 NEW: Check if this is the "Delivered" stage
//                 const isDeliveredStage = stage === "Delivered";

//                 // 🔥 MODIFIED: Stage is clickable only if: next stage, has selected items (for dine-in), AND NOT the "Delivered" stage
//                 const isClickable = isNextStage && hasSelectedItems && !isDeliveredStage;

//                 return (
//                   <React.Fragment key={index}>
//                     <div
//                       onClick={() => isClickable && handleStageClick(order, stage, index)}
//                       style={{
//                         ...styles.statusBox,
//                         backgroundColor: isCompleted
//                           ? "green"
//                           : isClickable
//                             ? "#ffd900ff"
//                             : "#f0f0f0ff",
//                         color: isCompleted ? "white" : "black",
//                         borderRadius: "6px",
//                         padding: window.innerWidth < 1100 ? "6px 10px" : "8px 12px",
//                         fontWeight: "bold",
//                         textTransform: "uppercase",
//                         transition: "all 0.3s ease",
//                         cursor: isClickable ? "pointer" : "default", // This already handles it
//                         boxShadow: isClickable ? "0 2px 8px rgba(0,0,0,0.3)" : "none",
//                         position: "relative",
//                         transform: isClickable ? "translateY(-2px)" : "none",
//                         // 🔥 ADD: Style specifically for disabled "Delivered" stage
//                         opacity: isDeliveredStage && !isCompleted ? 0.6 : 1,
//                       }}
//                       onMouseEnter={(e) => {
//                         if (isClickable) e.currentTarget.style.transform = "scale(1.05)";
//                       }}
//                       onMouseLeave={(e) => {
//                         if (isClickable) e.currentTarget.style.transform = "translateY(-2px)";
//                       }}
//                       title={isClickable ? `Click to mark as ${stage}` :
//                         isDeliveredStage ? "Delivered stage is disabled" :
//                           isCompleted ? `Already ${stage}` : ""}
//                     >
//                       {stage}
//                       {isClickable && !isDeliveredStage && ( // 🔥 Also exclude the pulsing dot for "Delivered"
//                         <span style={{
//                           position: "absolute",
//                           top: "-8px",
//                           right: "-8px",
//                           color: "white",
//                           borderRadius: "50%",
//                           width: "24px",
//                           height: "24px",
//                           fontSize: "14px",
//                           display: "flex",
//                           alignItems: "center",
//                           justifyContent: "center",
//                           fontWeight: "bold",
//                           animation: "pulse 2s infinite",
//                         }}>
//                         </span>
//                       )}
//                     </div>
//                     {index !== orderStages.length - 1 && <span style={styles.arrow}></span>}
//                   </React.Fragment>
//                 );
//               })} */}
//               </div>
//             </div>
//           );
//         })}

//       </div >
//     ),
//     Schedule: (<Schedule />),

//     "Status": (
//       <StandardOrderStatus
//         vendorId={vendorId}
//         statusOrders={statusOrders}
//         isLoadingStatus={isLoadingStatus}
//         currentPage={currentPage}
//         totalPages={totalPages}
//         selectedDate={selectedDate}
//         searchQuery={searchQuery}
//         onPrintReceipt={handlePrintReceipt}
//         onExportCSV={exportAllOrdersForCSV}
//         onDateChange={setSelectedDate}
//         onSearchChange={(value) => {
//           setSearchQuery(value);
//           setCurrentPage(0);
//         }}
//         onSearch={handleSearch}
//         onPageChange={setCurrentPage}
//         isPrinting={isPrinting}
//         printingOrderId={printingOrderId}
//       />
//     ),



//     // Status: (<StandardOrderStatus />)
//     //   <div style={{
//     //     display: 'flex',
//     //     flexDirection: 'column',
//     //     height: '100%',
//     //     minHeight: '55vh',
//     //     position: 'relative'
//     //   }}>
//     //     <div className="order-table-container">
//     //       <style>
//     //         {`
//     //     .order-table-container {
//     //       padding: 0px;
//     //       font-family: Arial, sans-serif;
//     //       width: 100%;
//     //       max-width: 100%;
//     //       box-sizing: border-box;
//     //       display: flex;
//     //       flex-direction: column;
//     //       height: 100%;
//     //     }

//     //     /* Fixed Header Section */
//     //     .fixed-header {
//     //       position: sticky;
//     //       top: 0;

//     //       background: white;
//     //       padding: 2px 0;
//     //       border-bottom: 0px solid #e0e0e0;
//     //       margin-bottom: 00px;
//     //     }

//     //     .filters {
//     //       display: flex;
//     //       justify-content: space-between;
//     //       align-items: center;
//     //       flex-wrap: wrap;
//     //       gap: 15px;
//     //       padding: 2px 0;
//     //       width: 100%;
//     //     }

//     //     .filters button {
//     //       padding: 8px 16px;
//     //       background-color: #b15cd6;
//     //       color: #fff;
//     //       border: none;
//     //       border-radius: 5px;
//     //       font-weight: bold;
//     //       cursor: pointer;
//     //       white-space: nowrap;
//     //       font-size: 14px;
//     //       height: 40px;
//     //     }

//     //     /* Scrollable Table Area */
//     //     .table-scroll-area {
//     //       flex: 1;
//     //       overflow-y: auto;
//     //       overflow-x: auto;
//     //       min-height: 60vh;
//     //       max-height: calc(100vh - 250px);
//     //       border: 0px solid #e0e0e0;
//     //       border-radius: 8px;
//     //       margin-bottom: 0px;
//     //       scrollbar-Width:thin;
//     //       -webkit-overflow-scrolling: touch;

//     //     }

//     //     /* Fixed Footer (Pagination) */
//     //     .fixed-footer {
//     //       position: sticky;
//     //       bottom: 0;
//     //       z-index: 100;
//     //       background: white;
//     //       padding: 5px 0;
//     //       border-top: 0px solid #e0e0e0;
//     //       margin-top: auto;
//     //     }

//     //     .pagination-controls {
//     //       display: flex;
//     //       justify-content: center;
//     //       align-items: center;
//     //       padding: 10px 0;
//     //       background: #f8f9fa;
//     //       border-radius: 8px;
//     //       flex-wrap: wrap;
//     //       gap: 10px;
//     //       width: 100%;
//     //     }

//     //     .pagination-buttons {
//     //       display: flex;
//     //       gap: 10px;
//     //       flex-wrap: wrap;
//     //       justify-content: center;
//     //     }

//     //     .pagination-btn {
//     //       padding: 6px 10px;
//     //       background-color: #b15cd6;
//     //       color: white;
//     //       border: none;
//     //       border-radius: 5px;
//     //       cursor: pointer;
//     //       font-weight: bold;
//     //       transition: background 0.3s;
//     //       font-size: 14px;
//     //     }

//     //     .pagination-btn:hover:not(:disabled) {
//     //       background-color: #9a4bc2;
//     //     }

//     //     .pagination-btn:disabled {
//     //       background-color: #ccc;
//     //       cursor: not-allowed;
//     //       color:black;
//     //     }

//     //     /* Table Styles */
//     //     table {
//     //       width: 100%;
//     //       border-collapse: collapse;
//     //       // min-width: 800px;
//     //     }

//     //     thead tr {
//     //       background-color: #b15cd6;
//     //       position: sticky;
//     //       top: 0;
//     //       z-index: 10;
//     //     }
//     //     td{
//     //       padding:0px 8px !important;
//     //     }

//     //     th, td {
//     //       padding: 8px 8px;
//     //       border: 1px solid #e0e0e0;
//     //       text-align: center;
//     //       font-size: 14px;
//     //       word-break: break-word;
//     //       white-space:nowrap;
//     //     }

//     //     tbody tr:nth-child(even) {
//     //       background-color: #f9f9f9;
//     //     }

//     //     tbody tr:nth-child(odd) {
//     //       background-color: #ffffff;
//     //     }

//     //     tbody tr:hover {
//     //       background-color: #f0e6f5;
//     //     }

//     //     /* Responsive Breakpoints */
//     //     @media (max-width: 1400px) {
//     //       table {
//     //         min-width: 700px;
//     //       }

//     //       .table-scroll-area {
//     //         max-height: calc(100vh - 240px);
//     //       }
//     //     }

//     //     @media (max-width: 1200px) {
//     //       table {
//     //         min-width: 600px;
//     //       }

//     //       th, td {
//     //         padding: 10px 12px;
//     //         font-size: 13px;
//     //       }
//     //     }

//     //     @media (max-width: 768px) {
//     //       .filters {
//     //         flex-direction: column;
//     //         align-items: stretch;
//     //         gap: 10px;
//     //       }

//     //       .filters > div {
//     //         width: 100%;
//     //         display: flex;
//     //         justify-content: space-between;
//     //       }

//     //       table {
//     //         min-width: 500px;
//     //       }

//     //       th, td {
//     //         padding: 8px 10px;
//     //         font-size: 12px;

//     //       }

//     //       .table-scroll-area {
//     //         max-height: calc(100vh - 280px);
//     //       }
//     //     }

//     //     @media (max-width: 576px) {
//     //       table {
//     //         min-width: 450px;
//     //       }

//     //       th, td {
//     //         padding: 6px 8px;
//     //         font-size: 11px;
//     //       }

//     //       .pagination-btn {
//     //         min-width: 70px;
//     //         padding: 6px 12px;
//     //         font-size: 12px;
//     //       }
//     //     }
//     //       .pagination-controls {
//     //   display: flex;
//     //   flex-direction: column;
//     //   align-items: center;
//     //   padding: 10px 0;
//     //   background: #f8f9fa;
//     //   border-radius: 8px;
//     //   width: 100%;
//     // }

//     // .pagination-buttons {
//     //   display: flex;
//     //   flex-wrap: nowrap; /* Prevent wrapping */
//     //   gap: 8px;
//     //   justify-content: center;
//     //   align-items: center;
//     //   width: 100%;
//     //   max-width: 700px; /* Limit maximum width */
//     //   overflow-x: auto; /* Allow horizontal scroll if needed */
//     //   padding: 5px;
//     // }

//     // .pagination-btn {
//     //   padding: 3px 8px;
//     //   background-color: #b15cd6;
//     //   color: white;
//     //   border: none;
//     //   border-radius: 5px;
//     //   cursor: pointer;
//     //   font-weight: bold;
//     //   font-size: 14px;
//     //   white-space: nowrap;
//     //   transition: background 0.3s;
//     //   flex-shrink: 0; /* Prevent buttons from shrinking */
//     // }

//     // .pagination-btn:hover:not(:disabled) {
//     //   background-color: #9a4bc2;
//     // }

//     // .pagination-btn:disabled {
//     //   background-color: #ccc;
//     //   cursor: not-allowed;
//     //   opacity: 0.7;
//     // }

//     // /* Responsive adjustments */
//     // @media (max-width: 768px) {
//     //   .pagination-buttons {
//     //     gap: 5px;
//     //     padding: 5px 2px;
//     //   }

//     //   .pagination-btn {
//     //     padding: 6px 8px;
//     //     font-size: 12px;
//     //     min-width: auto; /* Remove min-width on mobile */
//     //   }

//     //   .pagination-btn:first-child,
//     //   .pagination-btn:last-child {
//     //     // display: none; /* Hide First/Last on very small screens if needed */
//     //   }
//     // }

//     // @media (max-width: 576px) {
//     //   .pagination-buttons {
//     //     gap: 3px;
//     //   }

//     //   .pagination-btn {
//     //     padding: 5px 6px;
//     //     font-size: 11px;
//     //   }
//     // }

//     // /* For very small screens, show only essential buttons */
//     // @media (max-width: 400px) {
//     //   .pagination-buttons {
//     //     justify-content: space-between;
//     //     width: 100%;
//     //   }

//     //   .pagination-btn {
//     //     flex: 1; /* Make buttons take equal space */
//     //     padding: 6px 4px;
//     //     font-size: 11px;
//     //     text-align: center;
//     //   }
//     // }
//     //   @media (max-width:500px){
//     //   .filters{
//     //   padding:2px;
//     //   }
//     //   }
//     //   .fixed-footer{
//     //   padding:0px;
//     //   }
//     //   .order-table-container {
//     //       padding: 0px;
//     //       font-family: Arial, sans-serif;
//     //       width: 100%;
//     //       max-width: 100%;
//     //       box-sizing: border-box;
//     //       display: flex;
//     //       flex-direction: column;
//     //       height: 100%;
//     //     }

//     //     /* Update table header styles for new column */
//     //     table {
//     //       width: 100%;
//     //       border-collapse: collapse;
//     //       min-width: 800px; /* Increased for new column */
//     //     }

//     //     thead tr {
//     //       background-color: #b15cd6;
//     //       position: sticky;
//     //       top: 0;
//     //       z-index: 10;
//     //     }

//     //     th, td {
//     //       padding: 8px 8px;
//     //       border: 1px solid #e0e0e0;
//     //       text-align: center;
//     //       font-size: 14px;
//     //       word-break: break-word;
//     //       white-space: nowrap;
//     //     }

//     //     /* Print button styles */
//     //     .print-btn {
//     //       background: none;
//     //       border: none;
//     //       cursor: pointer;
//     //       font-size: 18px;
//     //       color: #b15cd6;
//     //       transition: color 0.3s;
//     //       padding: 5px;
//     //       border-radius: 4px;
//     //     }

//     //     .print-btn:hover {
//     //       color: #9a4bc2;
//     //       background: rgba(177, 92, 214, 0.1);
//     //     }

//     //     .print-btn:disabled {
//     //       cursor: not-allowed;
//     //       opacity: 0.5;
//     //     }

//     //     .print-btn.printing {
//     //       animation: pulse 1.5s infinite;
//     //     }

//     //     @keyframes pulse {
//     //       0% { opacity: 1; }
//     //       50% { opacity: 0.5; }
//     //       100% { opacity: 1; }
//     //     }

//     //     .print-dropdown {
//     //       position: relative;
//     //       display: inline-block;
//     //     }

//     //     .print-dropdown-content {
//     //       display: none;
//     //       position: absolute;
//     //       background-color: white;
//     //       min-width: 120px;
//     //       box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
//     //       z-index: 1;
//     //       right: 0;
//     //       top: 100%;
//     //       border-radius: 4px;
//     //       overflow: hidden;
//     //     }

//     //     .print-dropdown:hover .print-dropdown-content {
//     //       display: block;
//     //     }

//     //     .print-option {
//     //       padding: 10px 15px;
//     //       text-decoration: none;
//     //       display: block;
//     //       color: #333;
//     //       font-size: 14px;
//     //       cursor: pointer;
//     //       border-bottom: 1px solid #f0f0f0;
//     //     }

//     //     .print-option:hover {
//     //       background-color: #f5f5f5;
//     //     }

//     //     .print-option:last-child {
//     //       border-bottom: none;
//     //     }

//     //     .print-option i {
//     //       margin-right: 8px;
//     //     }
//     //   `}
//     //       </style>

//     //       {/* FIXED HEADER: Date Filter & Export Button */}
//     //       <div className="fixed-header" style={{
//     //         zIndex: window.innerWidth < 768 ? "-1" : "100",
//     //         width: window.innerWidth < 768 ? "94vw" : " "
//     //       }}>
//     //         <div className="filters">
//     //           {/* Main container with two sub-containers */}
//     //           <div style={{
//     //             display: 'flex',
//     //             flexDirection: window.innerWidth < 768 ? 'column' : 'row',
//     //             alignItems: 'stretch',
//     //             gap: '3px',
//     //             width: '100%',
//     //             justifyContent: "space-between"
//     //           }}>

//     //             {/* LEFT DIV: Export Button and Filter Button (Buttons Section) */}
//     //             <div style={{
//     //               display: 'flex',
//     //               flexDirection: window.innerWidth < 430 ? "row-reverse" : 'row',
//     //               alignItems: 'center',
//     //               gap: '10px',
//     //               flexShrink: 0,
//     //               justifyContent: "space-between"
//     //             }}>
//     //               {/* Export Button */}
//     //               <button
//     //                 onClick={() => exportAllOrdersForCSV()}
//     //                 style={{
//     //                   height: "40px",
//     //                   padding: "0px 20px",
//     //                   display: "flex",
//     //                   alignItems: "center",
//     //                   justifyContent: "center",
//     //                   whiteSpace: 'nowrap',
//     //                   background: "#b15cd6",
//     //                   color: "#fff",
//     //                   border: "none",
//     //                   borderRadius: "5px",
//     //                   fontWeight: "bold",
//     //                   cursor: "pointer",
//     //                   fontSize: "14px",
//     //                   minWidth: window.innerWidth < 500 ? "80px" : "100px"
//     //                 }}
//     //               >
//     //                 Export
//     //               </button>

//     //               {/* Date Filter Button */}
//     //               <div style={{ position: 'relative' }}>
//     //                 <input
//     //                   type="date"
//     //                   value={selectedDate}
//     //                   max={new Date().toISOString().split('T')[0]} // Add this line
//     //                   onChange={(e) => setSelectedDate(e.target.value)}
//     //                   style={{
//     //                     background: "#b15cd6",
//     //                     color: "#fff",
//     //                     border: "none",
//     //                     padding: "0px 16px",
//     //                     height: "40px",
//     //                     minWidth: window.innerWidth < 500 ? "120px" : "150px",
//     //                     cursor: "pointer",
//     //                     fontSize: "14px",
//     //                     borderRadius: "5px",
//     //                     fontWeight: "bold"
//     //                   }}
//     //                 />
//     //                 {/* Optional: Clear date button */}
//     //                 {selectedDate && (
//     //                   <button
//     //                     onClick={() => setSelectedDate("")}
//     //                     style={{
//     //                       position: 'absolute',
//     //                       right: '5px',
//     //                       top: '50%',
//     //                       transform: 'translateY(-50%)',
//     //                       background: 'none',
//     //                       border: 'none',
//     //                       cursor: 'pointer',
//     //                       color: '#fff',
//     //                       fontSize: '16px',
//     //                       padding: '0 5px'
//     //                     }}
//     //                   >
//     //                     ×
//     //                   </button>
//     //                 )}
//     //               </div>
//     //             </div>

//     //             {/* RIGHT DIV: Search Bar (Takes remaining space) */}

//     //             {/* In your search bar div, add a search button */}
//     //             <div style={{
//     //               minWidth: window.innerWidth < 768 ? '100%' : '200px'
//     //             }}>
//     //               <div style={{
//     //                 display: 'flex',
//     //                 gap: '5px',
//     //                 width: '100%'
//     //               }}>
//     //                 <div style={{ position: 'relative', flex: 1 }}>
//     //                   <input
//     //                     type="text"
//     //                     placeholder="Search by Order ID, Name, or Type..."
//     //                     value={searchQuery}
//     //                     onChange={(e) => {
//     //                       setSearchQuery(e.target.value);
//     //                       setCurrentPage(0);
//     //                     }}
//     //                     onKeyPress={(e) => {
//     //                       if (e.key === 'Enter') {
//     //                         if (searchQuery.trim() !== '') {
//     //                           handleSearch();
//     //                         } else {
//     //                           fetchPaginatedOrders(0);
//     //                         }
//     //                       }
//     //                     }}
//     //                     style={{
//     //                       width: '100%',
//     //                       padding: '8px 12px 8px 12px',
//     //                       border: '1px solid #ddd',
//     //                       borderRadius: '5px',
//     //                       fontSize: '14px',
//     //                       height: '40px',
//     //                       boxSizing: 'border-box',
//     //                       outline: "none"
//     //                     }}
//     //                   />

//     //                   {/* Clear search button */}
//     //                   {searchQuery && (
//     //                     <button
//     //                       onClick={() => {
//     //                         fetchPaginatedOrders(0);
//     //                         // Use the EXACT same logic as the Search button when it's empt
//     //                         setSearchQuery('');
//     //                         setCurrentPage(0);
//     //                       }}
//     //                       style={{
//     //                         position: 'absolute',
//     //                         right: '8px',
//     //                         top: '50%',
//     //                         transform: 'translateY(-50%)',
//     //                         background: 'none',
//     //                         border: 'none',
//     //                         cursor: 'pointer',
//     //                         color: '#666',
//     //                         fontSize: '18px',
//     //                         padding: '0',
//     //                         width: '20px',
//     //                         height: '20px',
//     //                         display: 'flex',
//     //                         alignItems: 'center',
//     //                         justifyContent: 'center'
//     //                       }}
//     //                       title="Clear search"
//     //                     >
//     //                       ×
//     //                     </button>
//     //                   )}
//     //                 </div>

//     //                 {/* Search Button */}
//     //                 {/* <button
//     //                   onClick={() => {
//     //                     if (searchQuery.trim() !== '') {
//     //                       handleSearch();
//     //                     } else {
//     //                       fetchPaginatedOrders(0);
//     //                     }
//     //                   }}
//     //                   style={{
//     //                     padding: '0px 15px',
//     //                     background: '#b15cd6',
//     //                     color: '#fff',
//     //                     border: 'none',
//     //                     borderRadius: '5px',
//     //                     cursor: 'pointer',
//     //                     fontSize: '14px',
//     //                     whiteSpace: 'nowrap',
//     //                     height: '40px'
//     //                   }}
//     //                   title="Search"
//     //                 >
//     //                   Search
//     //                 </button> */}
//     //               </div>
//     //             </div>

//     //           </div>
//     //         </div>
//     //       </div>



//     //       {/* SCROLLABLE TABLE AREA */}
//     //       <div className="table-scroll-area" style={{ width: window.innerWidth < 768 ? "94vw" : " " }}>
//     //         {isLoadingStatus ? (
//     //           <div style={{
//     //             display: 'flex',
//     //             justifyContent: 'center',
//     //             alignItems: 'center',
//     //             height: '200px',
//     //             width: '100%'
//     //           }}>
//     //             {showLoader && <div>Loading...</div>}
//     //           </div>
//     //         ) : (
//     //           // Update the table to include the print button
//     //           <table>
//     //             <thead>
//     //               <tr>
//     //                 {/* <th>S.No</th> */}
//     //                 <th>Order ID</th>
//     //                 <th>User Name</th>
//     //                 <th>Date</th>
//     //                 <th>Category</th>
//     //                 <th>Type</th>
//     //                 <th>Payment</th>
//     //                 <th>Status</th>
//     //                 <th>Amount</th>
//     //                 <th>Print</th>
//     //               </tr>
//     //             </thead>

//     //             <tbody>
//     //               {statusOrders.length === 0 ? (
//     //                 <tr>
//     //                   <td colSpan="10" style={{
//     //                     textAlign: "center",
//     //                     padding: "60px",
//     //                     fontSize: "16px",
//     //                     color: "#666"
//     //                   }}>
//     //                     {selectedDate ? `No orders found for ${selectedDate}` : "No orders found"}
//     //                   </td>
//     //                 </tr>
//     //               ) : (
//     //                 statusOrders.map((item, index) => (
//     //                   <tr key={index}>
//     //                     {/* <td>{(currentPage * 10) + index + 1}</td> */}
//     //                     <td>{item.orderId}</td>
//     //                     <td>
//     //                       <span style={{
//     //                         fontWeight: item.userName !== "Guest" ? "500" : "normal",
//     //                         color: item.userName !== "Guest" ? "#333" : "#666"
//     //                       }}>
//     //                         {item.userName ? item.userName : "Guest"}
//     //                       </span>
//     //                     </td>
//     //                     <td>{new Intl.DateTimeFormat("en-GB").format(new Date(item.orderDateAndTime))}</td>
//     //                     <td>Food</td>
//     //                     <td>{item.orderType == "DINE_IN" ? "DINEIN" : item.orderType == "TABLE_DINE_IN" ? "TABLE DINEIN" : item.orderType}</td>
//     //                     <td>
//     //                       {item.paymentMethod === "Online_Payment" ? "Online" :
//     //                         item.paymentMethod === "Maamaas_Wallet" ? "Wallet" :
//     //                           item.paymentMethod}
//     //                     </td>
//     //                     <td>
//     //                       <span style={{
//     //                         padding: "4px 8px",
//     //                         borderRadius: "4px",
//     //                         fontSize: "12px",
//     //                         fontWeight: "bold",
//     //                         backgroundColor: getStatusColorr(item.status),
//     //                         color: "white",
//     //                         display: "inline-block",
//     //                         minWidth: "80px"
//     //                       }}>
//     //                         {getStatusTextt(item.status)}
//     //                       </span>
//     //                     </td>
//     //                     <td>₹{Math.round(item.grandTotal)}</td>
//     //                     <td>
//     //                       <button
//     //                         onClick={() => handlePrintReceipt(item)}
//     //                         disabled={isPrinting && printingOrderId === item.orderId}
//     //                         style={{
//     //                           background: 'none',
//     //                           border: 'none',
//     //                           cursor: isPrinting && printingOrderId === item.orderId ? 'not-allowed' : 'pointer',
//     //                           fontSize: '18px',
//     //                           color: '#b15cd6',
//     //                           padding: '5px',
//     //                           borderRadius: '4px',
//     //                           transition: 'all 0.3s',
//     //                           opacity: isPrinting && printingOrderId === item.orderId ? 0.5 : 1
//     //                         }}
//     //                         title="Print Receipt"
//     //                         onMouseOver={(e) => {
//     //                           if (!(isPrinting && printingOrderId === item.orderId)) {
//     //                             e.target.style.color = '#9a4bc2';
//     //                             e.target.style.background = 'rgba(177, 92, 214, 0.1)';
//     //                           }
//     //                         }}
//     //                         onMouseOut={(e) => {
//     //                           if (!(isPrinting && printingOrderId === item.orderId)) {
//     //                             e.target.style.color = '#b15cd6';
//     //                             e.target.style.background = 'none';
//     //                           }
//     //                         }}
//     //                       >
//     //                         <FaPrint />
//     //                       </button>
//     //                     </td>
//     //                   </tr>
//     //                 ))
//     //               )}
//     //             </tbody>
//     //           </table>
//     //         )}
//     //       </div>




//     //       {/* FIXED FOOTER: Pagination */}
//     //       {/* FIXED FOOTER: Pagination */}
//     //       {statusOrders.length > 0 && !isLoadingStatus && totalPages > 1 && (
//     //         <div className="fixed-footer">
//     //           <div className="pagination-controls">
//     //             <div className="pagination-buttons">
//     //               {/* FIRST PAGE BUTTON */}
//     //               <button
//     //                 disabled={currentPage === 0 || isLoadingStatus}
//     //                 onClick={goToFirstPage}
//     //                 className="pagination-btn"
//     //                 title="Go to first page"
//     //               >
//     //                 ⏮
//     //               </button>

//     //               {/* PREVIOUS BUTTON */}
//     //               <button
//     //                 disabled={currentPage === 0 || isLoadingStatus}
//     //                 onClick={goToPreviousPage}
//     //                 className="pagination-btn"
//     //                 title="Previous page"
//     //               >
//     //                 ◀
//     //               </button>

//     //               {/* PAGE NUMBER BUTTONS */}
//     //               {getVisiblePages().map((pageNum) => (
//     //                 <button
//     //                   key={pageNum}
//     //                   onClick={() => setCurrentPage(pageNum)}
//     //                   className="pagination-btn"
//     //                   style={{
//     //                     backgroundColor: currentPage === pageNum ? "#31173eff" : "#b15cd6",
//     //                     fontWeight: currentPage === pageNum ? "bold" : "normal",
//     //                     minWidth: '40px'
//     //                   }}
//     //                   title={`Go to page ${pageNum + 1}`}
//     //                 >
//     //                   {pageNum + 1}
//     //                 </button>
//     //               ))}

//     //               {/* NEXT BUTTON */}
//     //               <button
//     //                 disabled={currentPage >= totalPages - 1 || isLoadingStatus}
//     //                 onClick={goToNextPage}
//     //                 className="pagination-btn"
//     //                 title="Next page"
//     //               >
//     //                 ▶
//     //               </button>

//     //               {/* LAST PAGE BUTTON */}
//     //               <button
//     //                 disabled={currentPage >= totalPages - 1 || isLoadingStatus}
//     //                 onClick={goToLastPage}
//     //                 className="pagination-btn"
//     //                 title="Go to last page"
//     //               >
//     //                 ⏭
//     //               </button>
//     //             </div>

//     //           </div>
//     //         </div>
//     //       )}
//     //     </div>
//     //   </div>


//   };

//   return (

//     <div>

//       <style>{`
//         .main-container {
//           padding: 20px;
//           display: flex;
//           flex-direction: column;

//         }
// @media screen and (min-width: 768px) {
//          .tabs-wrapperyyy {
//           display: flex;
//           flex-direction: column;
//           align-items: center;
//           gap: 10px;
//           margin-left:0px;
//           margin-top:-46px;
// }
//       }


// /* Mobile view ke liye (max-width 768px ya 600px aapke design ke hisaab se) */
// @media screen and (max-width: 768px) {
//   .tabs-wrapper {
//     margin-left: 0;

//   }
//        .tabs-wrapperyyy {
//       display: flex;
//           flex-direction: column;
//           align-items: center;
//           gap: 10px;
//           margin-left:0px;
//           margin-top:-30px;
// }
//             .tab-content {
//           width: 100%;
//           max-width:944px;


//         }
// }


//         .tab-buttons {
//           display: flex;
//           flex-wrap: wrap;
//           justify-content: center;
//           gap: 10px;
//           margin-top:30px;

//         }

//         .tab-button {
//           border: none;
//           border-radius: 10px;
//           width: auto;
//           height: 40px;
//           background-color: #d9d9d9;
//           color: #000;
//           font-weight: bold;
//           cursor: pointer;
//           transition: background-color 0.3s ease;
//         }

//         .tab-button.active {
//           color:white;
//           background-color: #b15cd6;
//         }



//         .sidebar {
//           margin-top: 30px;
//           max-height: 600px;
//           overflow-y: auto;
//         }

//         .card {
//           width: 100%;
//           max-width: 300px;
//           height: 120px;
//           background: #ccc;
//           border-radius: 8px;
//           box-shadow: 0px 2px 4px rgba(0,0,0,0.1);
//           margin: 10px auto;
//           position: relative;
//           padding: 10px;
//         }

//         .card h5, .card p {
//           color: white;
//           margin: -18 !imortanant;
//         }




//         @media (min-width: 768px) {
//           .main-container {
//             flex-direction: row;
//             justify-content: space-between;
//           }
//   .tab-content {
//           margin-top: 0px;
//           width: 100%;
//           max-width:944px;

//         }

//          .left-column {
//     padding-right: 0;
//     display: flex;
//     flex-direction: column;         /* stack children vertically */

//     justify-content: center;        /* center vertically */
//     text-align: start;
//     margin: 0 auto;
//   }

//           .right-column {
//             width: 30%;
//             position: sticky;
//             top: -30px;
//             max-height: 700px;
//             overflow-y: auto;
//           }

//           .card {
//             margin-left: 0;
//           }
//             .tabs-wrapperyyy{
//             margin-left:none

//             }

//         }

//         /* Hide native scrollbars */
//         .sidebar::-webkit-scrollbar,
//         .left-column::-webkit-scrollbar {
//           width: 0px;
//           background: transparent;
//         }


// /* Media queries for different screen heights */
// @media (max-height: 400px) {
//   .tab-content {
//     height: 50vh !important;
//   }
// }

// @media (min-height: 401px) and (max-height: 500px) {
//   .tab-content {
//     height: 50vh !important;
//   }
// }

// @media (min-height: 501px) and (max-height: 600px) {
//   .tab-content {
//     height: 50vh !important;
//   }
// }

// /* For screens taller than 600px */
// @media (min-height: 601px)and (max-height: 700px) {
//   .tab-content {
//     height: 55vh !important; /* Or use your containerHeight value */
//   }
// }
//   @media (min-height : 701px){
//   .tab-content {
//     height: 60vh !important; /* Or use your containerHeight value */
//   }
//   }
//   .borderleft{
//     border-left:1px solid #bfbfbf !important;
//     }
//       `}</style>

//       <div className="container-fluid">
//         <div className="row">
//           {/* <div className="col-lg-2 col-md-12 col-sm-12 col-12"></div> */}
//           <div className="col-lg-12 col-md-12 col-sm-12 col-12">


//             {/* Left Section */}
//             <div className="left-column" style={{}}>
//               <div className="tabs-wrapperyyy ">

//                 <div className="tab-buttons" style={{}}>
//                   {Object.keys(tabContent).map((label) => (
//                     <button
//                       key={label}
//                       className={`tab-button ${activeTab === label ? "active" : ""}`}
//                       onClick={() => setActiveTab(label)}
//                       style={{minWidth:window.innerWidth<380 ? " " : "100px"}}
//                     >
//                       {label}
//                     </button>
//                   ))}
//                 </div>
//                 <div className="tab-content" style={{
//                   // overflow: 'auto',
//                   // scrollbarWidth: "thin",
//                   msOverflowStyle: "none", maxWidth: '944px',
//                   width: window.innerWidth < 500 ? "90vw" : " ",
//                 }}>{tabContent[activeTab]}</div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>


//   );
// };

// export default Standardorder;







import React, { useState, useEffect } from 'react';
import './Management.css';
import { FaTrash, FaEye, FaPrint, FaSearch } from 'react-icons/fa'; // Added FaPrint and FaSearch
import axios from 'axios';
// import Schedule from './ScheduleOrder';
import { useLoader } from '../../../../context/LoaderProvider';
import StandardOrderStatus from './StandardOrderStatus';
import Menudatas from '../../Menumanagment/Food/Menudatas';
// Add these imports at the top
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import Orders from './Orders';

const Standardorder = () => {
  const [activeTab, setActiveTab] = useState('Products');
  const [data, setData] = useState([]);
  const [orders, setOrders] = useState([]);
  const { showLoader, hideLoader } = useLoader();
  const [loading, setLoading] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  // Add these with your other useState declarations
  const [isPrinting, setIsPrinting] = useState(false);
  const [printingOrderId, setPrintingOrderId] = useState(null);
  // Add with other state variables
  const [allOrdersForSearch, setAllOrdersForSearch] = useState([]);

  const [vendorId, setVendorId] = useState(null);
  const [allOrders, setAllOrders] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const screenWidth = window.innerWidth;
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  // Add these with your other useState declarations:
  const [pageSize] = useState(10); // Fixed at 10
  const [totalElements, setTotalElements] = useState(0);
  const [filteredOrders, setFilteredOrders] = useState([]);
  // Add new state for receipt
  const [receiptData, setReceiptData] = useState(null);
  const [selectedOrderForReceipt, setSelectedOrderForReceipt] = useState(null);

  const [hasMorePages, setHasMorePages] = useState(true);
  const [pageNumbers, setPageNumbers] = useState([0]); // For P-1, P, P+1

  const [statusOrders, setStatusOrders] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [isLoadingStatus, setIsLoadingStatus] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedDate, setSelectedDate] = useState("");
  // Add this with your other useState declarations
  const [tabLoading, setTabLoading] = useState(false);

  // Add state for top search bar
  const [globalSearchQuery, setGlobalSearchQuery] = useState('');
  const [isSearching, setIsSearching] = useState(false);
  const [searchResult, setSearchResult] = useState(null);
  const [showSearchResult, setShowSearchResult] = useState(false);

  const containerHeight = window.innerWidth < 768
    ? '300px'       // Mobile
    : window.innerWidth < 850
      ? '300px'     // Below 850px
      : window.innerWidth < 1400
        ? '410px'   // Between 850px and 1399px
        : window.innerWidth < 1600
          ? '480px' // Between 1400px and 1599px
          : '640px'; // Above 1600px






  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Get your existing loader functions

  // const handleTabChange = (label) => {
  //   // Show loader
  //   showLoader();

  //   // Change tab immediately
  //   setActiveTab(label);

  //   // Hide loader after a short delay (or after content loads)
  //   // You can adjust the timing based on your content
  //   setTimeout(() => {
  //     hideLoader();
  //   }, 1); // Short delay for smooth transition
  // };

  useEffect(() => {
    let filtered = [...statusOrders];

    if (selectedDate) {
      const s = new Date(selectedDate);
      s.setHours(0, 0, 0, 0);

      const e = new Date(selectedDate);
      e.setHours(23, 59, 59, 999);

      filtered = filtered.filter(order => {
        const date = new Date(order.orderDateAndTime);
        return date >= s && date <= e;
      });
    }

    setFilteredOrders(filtered);
  }, [selectedDate, statusOrders]);

  // Fetch orders from API
  useEffect(() => {
    if (!vendorId) return;

    const fetchOrders = async () => {
      const token = localStorage.getItem("authToken");
      if (!token) {
        console.error("Authorization token missing");
        return;
      }

      try {
        let pageIndex = 0;
        let allNormalOrders = [];
        let morePages = true;

        // 🔵 Fetch ALL PAGINATED ORDERS page by page
        while (morePages) {
          const res = await axios.get(
            `https://backend.maamaas.com/food/api/orders/vendor/paginated/${vendorId}/${pageIndex}/10`,
            { headers: { Authorization: `Bearer ${token}` } }
          );

          const response = res.data;

          if (!response || !Array.isArray(response.content)) break;

          const pageData = response.content;

          if (pageData.length === 0) break;

          allNormalOrders = [...allNormalOrders, ...pageData];

          if (pageData.length < 10) {
            morePages = false;
          } else {
            pageIndex++;
          }
        }

        // 🔵 Fetch DINE-IN completed orders
        const dineInRes = await axios.get(
          `https://backend.maamaas.com/food/api/cart/get/ordertype=TABLE_DINE_IN/${vendorId}/COMPLETED`,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        const dineInRaw = dineInRes.data || [];

        const dineInOrders = dineInRaw.map((order) => ({
          orderId: order.cartId,
          orderDateAndTime: order.cartDateAndTime || new Date().toISOString(),
          appType: "Food",
          orderService: order.orderType,
          userName: order.userName || "Dine-In User",
          paymentMethod: order.paymentMethod || "N/A",
          status: "COMPLETED",
          grandTotal: order.grandTotal || 0,
        }));

        // 🔥 Combine both
        const allData = [...allNormalOrders, ...dineInOrders];


        setAllOrders(allData);
        setFilteredData(allData); // initial display

      } catch (error) {
        console.error("Error fetching orders:", error);
      }
    };

    fetchOrders();
  }, [vendorId]);

  const [allFilteredOrders, setAllFilteredOrders] = useState([]);

  // Filter orders whenever selectedDate changes
  useEffect(() => {
    if (!selectedDate) {
      setAllFilteredOrders(allOrders);
    } else {
      const filtered = allOrders.filter((order) => {
        const orderDate = new Date(order.orderDateAndTime)
          .toISOString()
          .split("T")[0];
        return orderDate === selectedDate;
      });
      setAllFilteredOrders(filtered);
    }
  }, [selectedDate, allOrders]);

  // Then update pagination based on allFilteredOrders
  useEffect(() => {
    if (allFilteredOrders.length > 0) {
      const startIndex = currentPage * 10;
      const pageOrders = allFilteredOrders.slice(startIndex, startIndex + 10);

      const formatted = pageOrders.map(order => ({
        orderId: order.orderId,
        orderDateAndTime: order.orderDateAndTime,
        orderType: order.orderType?.replace(/[_-]/g, "") ?? "N/A",
        paymentMethod: order.paymentMethod?.replace(/[_-]/g, "") ?? "N/A",
        status: order.status,
        grandTotal: order.grandTotal ?? 0,
      }));

      setStatusOrders(formatted);
      setTotalPages(Math.ceil(allFilteredOrders.length / 10));
    }
  }, [allFilteredOrders, currentPage]);




  useEffect(() => {
    const storedVendorId = localStorage.getItem("vendorId");
    if (storedVendorId) {
      setVendorId(storedVendorId);
    }
  }, []);

  // Modified fetchOrders function to include delivery API calls for DELIVERY/TAKEAWAY orders
  useEffect(() => {
    if (!vendorId) return;

    fetchOrders(); // Initial fetch

    const intervalId = setInterval(fetchOrders, 5000); // Poll every 5 seconds
    return () => clearInterval(intervalId);
  }, [vendorId]);

  const [combinedData, setCombinedData] = useState([]);

  useEffect(() => {
    if (!vendorId) return;

    const fetchData = () => {
      const token = localStorage.getItem("authToken"); // ✅ Retrieve token from storage
      if (!token) {
        console.warn("No auth token found. Skipping fetch.");
        return;
      }

      axios
        .get(
          `https://backend.maamaas.com/food/api/orders/vendor/${vendorId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`, // ✅ Include token in header
            },
          }
        )
        .then((res) => setData(res.data))
        .catch((err) =>
          console.error("Error fetching orders with token:", err.response?.data || err.message)
        );
    };

    fetchData(); // initial fetch

    const interval = setInterval(fetchData, 100000); // fetch every 1 second

    return () => clearInterval(interval); // cleanup
  }, [vendorId]);

  const getTotalOrdersCount = async () => {
    if (!vendorId) return 0;

    const token = localStorage.getItem("authToken");
    try {
      const response = await axios.get(
        `https://backend.maamaas.com/food/api/orders/vendor/statistics/${vendorId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      return response.data.totalOrders || 0;
    } catch (error) {
      console.error("Error fetching total orders count:", error);
      return 0;
    }
  };


  const fetchPaginatedOrders = async (page = 0) => {
    if (!vendorId) return;

    setIsLoadingStatus(true);
    const token = localStorage.getItem("authToken");

    try {
      // 1. Fetc
      // h current page
      // showLoader();
      let apiUrl = `https://backend.maamaas.com/food/api/orders/vendor/paginated/${vendorId}/${page}/10`;

      const params = new URLSearchParams();
      if (selectedDate) params.append('date', selectedDate);
      if (searchQuery.trim() !== '') params.append('search', searchQuery);

      const queryString = params.toString();
      if (queryString) apiUrl += `?${queryString}`;

      const response = await axios.get(apiUrl, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const orders = response.data || [];

      // 2. Calculate total pages from statistics
      let calculatedTotalPages = totalPages; // Keep current by default

      // Only recalculate on first page or when filters change
      if (page === 0) {
        if (selectedDate || searchQuery.trim() !== '') {
          // For filtered/search results, we need to count differently
          // Fetch all orders and count filtered ones
          const allResponse = await axios.get(
            `https://backend.maamaas.com/food/api/orders/vendor/${vendorId}`,
            { headers: { Authorization: `Bearer ${token}` } }
          );

          let allOrders = allResponse.data || [];

          // Apply same filters
          if (selectedDate) {
            allOrders = allOrders.filter(order => {
              const orderDate = new Date(order.orderDateAndTime)
                .toISOString()
                .split("T")[0];
              return orderDate === selectedDate;
            });
          }

          if (searchQuery.trim() !== '') {
            const query = searchQuery.toLowerCase().trim();
            allOrders = allOrders.filter(order => {
              const orderIdMatch = order.orderId?.toString().toLowerCase().includes(query);
              const userNameMatch = order.userName?.toLowerCase().includes(query);
              const orderTypeMatch = order.orderType?.toLowerCase().includes(query);
              return orderIdMatch || userNameMatch || orderTypeMatch;
            });
          }

          calculatedTotalPages = Math.max(1, Math.ceil(allOrders.length / 10));
        } else {
          // Normal view - use statistics API
          const totalOrdersCount = await getTotalOrdersCount();
          calculatedTotalPages = Math.max(1, Math.ceil(totalOrdersCount / 10));
        }

      }

      // 3. Update state
      setStatusOrders(orders);
      setTotalPages(calculatedTotalPages); // ✅ Now this is accurate!
      setCurrentPage(page);

    } catch (error) {
      console.error("Error fetching orders:", error);
      setStatusOrders([]);
      setTotalPages(1);
      setCurrentPage(0);
    } finally {
      setIsLoadingStatus(false);
      // hideLoader();
    }
  };




  // Update goNext and goPrevious functions:
  const goToFirstPage = () => setCurrentPage(totalPages - totalPages);
  const goToPreviousPage = () => setCurrentPage(prev => Math.max(0, prev - 1));
  const goToNextPage = () => setCurrentPage(prev => Math.min(totalPages - 1, prev + 1));
  const goToLastPage = () => setCurrentPage(totalPages - 1);

  // Helper to get page numbers to display
  const getVisiblePages = () => {
    const pages = [];

    // Always show current page
    pages.push(currentPage);

    // Show previous page if exists
    if (currentPage > 0) {
      pages.unshift(currentPage - 1);
    }

    // Show next page if exists
    if (currentPage < totalPages - 1) {
      pages.push(currentPage + 1);
    }

    // If we have less than 3 pages, add more if available
    if (pages.length < 3) {
      if (currentPage > 1) {
        pages.unshift(currentPage - 2);
      }
      if (currentPage < totalPages - 2) {
        pages.push(currentPage + 2);
      }
    }

    // Sort and return unique pages
    return [...new Set(pages)].sort((a, b) => a - b);
  };
  useEffect(() => {
    if (vendorId && activeTab === 'Status') {
      if (searchQuery.trim() !== '') {
        handleSearch();
      } else {
        fetchPaginatedOrders(currentPage);
      }
    }
  }, [currentPage, vendorId, activeTab, selectedDate, searchQuery]);

  const handleSearch = async (searchType = "orderId") => {
    if (!vendorId) return;

    // If search is empty, fetch normal orders
    if (searchQuery.trim() === '') {
      fetchPaginatedOrders(0);
      return;
    }

    setIsLoadingStatus(true);
    const token = localStorage.getItem("authToken");

    try {
      let filteredOrders = [];
      let allOrders = [];

      // DIFFERENT API FOR ORDER ID SEARCH
      if (searchType === 'orderId') {
        try {
          // Use the specific order ID API
          const response = await axios.get(
            `https://backend.maamaas.com/food/api/orders/order/${searchQuery.trim()}`,
            { headers: { Authorization: `Bearer ${token}` } }
          );

          // The API returns a single order object
          const order = response.data;
          if (order) {
            // Convert single order to array for consistency
            filteredOrders = [order];
          } else {
            filteredOrders = [];
          }
        } catch (error) {
          console.error("Error fetching order by ID:", error);
          filteredOrders = [];
        }
      } else {
        // FOR OTHER SEARCH TYPES: Use the vendor orders API
        const response = await axios.get(
          `https://backend.maamaas.com/food/api/orders/vendor/${vendorId}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        allOrders = response.data || [];

        // Apply date filter
        if (selectedDate) {
          allOrders = allOrders.filter(order => {
            const orderDate = new Date(order.orderDateAndTime)
              .toISOString()
              .split("T")[0];
            return orderDate === selectedDate;
          });
        }

        // Apply search filter based on search type
        const query = searchQuery.toLowerCase().trim();
        filteredOrders = allOrders.filter(order => {
          switch (searchType) {
            case 'userName':
              return order.userName?.toLowerCase().includes(query);
            case 'orderType':
              return order.orderType?.toLowerCase().includes(query);
            case 'paymentMethod':
              return order.paymentMethod?.toLowerCase().includes(query);
            case 'status':
              return order.status?.toLowerCase().includes(query);
            default:
              // For safety, include all fields
              const orderIdMatch = order.orderId?.toString().toLowerCase().includes(query);
              const userNameMatch = order.userName?.toLowerCase().includes(query);
              const orderTypeMatch = order.orderType?.toLowerCase().includes(query);
              const paymentMethodMatch = order.paymentMethod?.toLowerCase().includes(query);
              const statusMatch = order.status?.toLowerCase().includes(query);
              return orderIdMatch || userNameMatch || orderTypeMatch || paymentMethodMatch || statusMatch;
          }
        });
      }

      // Sort and paginate
      filteredOrders.sort((a, b) => new Date(b.orderDateAndTime) - new Date(a.orderDateAndTime));

      const totalElements = filteredOrders.length;
      const totalPages = Math.max(1, Math.ceil(totalElements / 10));

      const startIndex = currentPage * 10;
      const pageOrders = filteredOrders.slice(startIndex, startIndex + 10);

      // Format
      const formatted = pageOrders.map(order => ({
        orderId: order.orderId,
        orderDateAndTime: order.orderDateAndTime || order.createdAt,
        orderType: order.orderType?.replace(/[_-]/g, "") ?? "N/A",
        paymentMethod: order.paymentMethod?.replace(/[_-]/g, "") ?? "N/A",
        status: order.status,
        grandTotal: order.grandTotal ?? 0,
        userName: order.userName ? order.userName.trim() : "Guest",
      }));

      setStatusOrders(formatted);
      setTotalPages(totalPages);

    } catch (error) {
      console.error("Search error:", error);
      setStatusOrders([]);
      setTotalPages(1);
    } finally {
      setIsLoadingStatus(false);
    }
  };

  // MODIFIED: Fetch orders function with delivery API integration for DELIVERY/TAKEAWAY orders
  const fetchOrders = async () => {
    if (!vendorId) return;

    const token = localStorage.getItem("authToken");

    try {
      // Fetch ALL active orders
      const response = await axios.get(
        `https://backend.maamaas.com/food/api/orders/status-range`,
        {
          params: {
            vendorId: vendorId,
            fromStatus: "CONFIRMED",
            toStatus: "WAITING_FOR_PICKUP",
          },
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      let allOrders = response.data || [];

      // 🔥 REMOVED FILTER: Keep all orders regardless of userId
      // allOrders = allOrders.filter(order => order.userId !== null && order.userId !== undefined);

      // Fetch delivery data for DELIVERY and TAKEAWAY orders
      const deliveryTakeawayOrders = allOrders.filter(order =>
        order.orderType === "DELIVERY" || order.orderType === "TAKEAWAY"
      );

      // Fetch delivery API data for each DELIVERY/TAKEAWAY order
      const deliveryPromises = deliveryTakeawayOrders.map(async (order) => {
        try {
          const deliveryResponse = await axios.get(
            `https://backend.maamaas.com/delivery/api/get/order`,
            {
              params: {
                orderId: order.orderId,
                appType: "FOOD_AND_BEVERAGES"
              },
              headers: { Authorization: `Bearer ${token}` }
            }
          );

          return {
            ...order,
            vendorOtp: deliveryResponse.data?.vendorOtp,
            userOtp: deliveryResponse.data?.userOtp,
            deliveryAddress: deliveryResponse.data?.deliveryAddress || order.deliveryAddress,
            deliveryStatus: deliveryResponse.data?.status,
          };
        } catch (error) {
          // If delivery API fails, keep the original order data
          console.warn(`Delivery API failed for order ${order.orderId}:`, error.message);
          return order;
        }
      });

      // Wait for all delivery API calls to complete
      const ordersWithDeliveryData = await Promise.allSettled(deliveryPromises);
      const updatedOrders = ordersWithDeliveryData.map(result =>
        result.status === "fulfilled" ? result.value : result.reason
      );

      // Also fetch dine-in orders for relevant statuses
      const dineInStatuses = ["PROCESSING", "BEING_PREPARED", "ORDER_IS_READY", "WAITING_FOR_PICKUP"];
      const dineInPromises = dineInStatuses.map(status =>
        axios.get(
          `https://backend.maamaas.com/food/api/cart/get/ordertype=TABLE_DINE_IN/${vendorId}/${status}`,
          { headers: { Authorization: `Bearer ${token}` } }
        )
      );

      const dineInResponses = await Promise.all(dineInPromises);
      let dineInOrders = dineInResponses.flatMap(res => res.data || []);

      // 🔥 REMOVED FILTER DINE-IN: Keep all dine-in orders regardless of userId
      // dineInOrders = dineInOrders.filter(order => order.userId !== null && order.userId !== undefined);

      // Filter TABLE_DINE_IN orders by cartItems status
      dineInOrders = dineInOrders.filter(order =>
        Array.isArray(order.cartItems) &&
        order.cartItems.some(item =>
          ["PROCESSING", "BEING_PREPARED", "ORDER_IS_READY", "WAITING_FOR_PICKUP"].includes(item.orderStatus)
        )
      );

      // Combine and deduplicate
      const combinedOrders = [...updatedOrders, ...dineInOrders];
      const uniqueOrders = combinedOrders.filter(
        (order, index, self) =>
          index === self.findIndex(
            o => (o.cartId && o.cartId === order.cartId) || (o.orderId && o.orderId === order.orderId)
          )
      );

      // Sort orders by date in ASCENDING order (oldest first)
      const sortedOrders = uniqueOrders.sort((a, b) => {
        const dateA = new Date(a.orderDateAndTime || a.cartDateAndTime || 0);
        const dateB = new Date(b.orderDateAndTime || b.cartDateAndTime || 0);
        return dateA - dateB; // For ascending order (oldest first)
      });

      setOrders(sortedOrders);

    } catch (error) {
      console.error("❌ Failed to fetch orders:", error.response?.data || error.message);
    }
  };

  // 2. Helper to get selected dine-in items
  const getSelectedDineInItems = (order) => {
    if (!order.cartItems || order.orderType !== "TABLE_DINE_IN") return [];

    // Get selected items from selectedItems state
    const orderId = order.orderId || order.cartId;
    const selectedIndexes = selectedItems[orderId] || [];

    return order.cartItems.filter((item, index) =>
      selectedIndexes.includes(index)
    );
  };

  // 3. Function to get selected dine-in item IDs
  const getSelectedDineInItemIds = (order) => {
    const selectedItemsList = getSelectedDineInItems(order);
    return selectedItemsList.map(item => item.itemId).filter(id => id);
  };

  // 4. Helper to get current stage index
  const getCurrentStageIndex = (order) => {
    const stageOrder = ["Placed", "Preparing", "Prepared", "Dispatched", "Delivered"];
    const statusToStage = {
      CONFIRMED: "Placed",
      PROCESSING: "Preparing",      // ← CHANGE from "Placed" to "Preparing"
      BEING_PREPARED: "Preparing", // Map to same as PROCESSING
      ORDER_IS_READY: "Prepared",   // Keep
      WAITING_FOR_PICKUP: "Dispatched", // Keep
      DELIVERED: "Delivered"        // ← CHANGE from COMPLETED to DELIVERED
    };

    if (order.orderType === "TABLE_DINE_IN" && Array.isArray(order.cartItems)) {
      // For dine-in, find the highest completed stage among ALL items
      const itemStatuses = order.cartItems.map(item => item.orderStatus);
      let highestStageIndex = 0;

      itemStatuses.forEach(status => {
        const stage = statusToStage[status] || "Placed";
        const stageIndex = stageOrder.indexOf(stage);
        if (stageIndex > highestStageIndex) {
          highestStageIndex = stageIndex;
        }
      });

      return highestStageIndex;
    } else {
      // For normal orders
      const currentStage = statusToStage[order.status] || "Placed";
      return stageOrder.indexOf(currentStage);
    }
  };

  // 5. Function to update normal order status
  const updateOrderStatus = async (orderId, newStatus) => {
    const token = localStorage.getItem("authToken");
    if (!token) {
      alert("Authentication token missing");
      return false;
    }

    try {
      // Map UI status to API status values
      const statusMap = {
        "Preparing": "BEING_PREPARED",        // ← CHANGE to PROCESSING
        "Prepared": "ORDER_IS_READY",     // Keep (correct)
        "Dispatched": "WAITING_FOR_PICKUP", // Keep (correct)
        "Delivered": "DELIVERED"          // ← CHANGE to DELIVERED
      };


      const apiStatus = statusMap[newStatus];

      const response = await axios.put(
        `https://backend.maamaas.com/food/api/orders/edit-orders/${orderId}/${apiStatus}`,
        { status: apiStatus },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      return true;
    } catch (error) {
      console.error(`Failed to update order status to ${newStatus}:`, error);
      alert(`Failed to update status: ${error.response?.data?.message || error.message}`);
      return false;
    }
  };

  // 6. Function to update TABLE_DINE_IN cart items status
  const updateDineInItemsStatus = async (cartId, itemIds, newStatus) => {
    const token = localStorage.getItem("authToken");
    if (!token) {
      alert("Authentication token missing");
      return false;
    }

    try {
      // Map UI status to API status values for dine-in
      const statusMap = {
        "Preparing": "BEING_PREPARED",        // ← CHANGE to PROCESSING
        "Prepared": "ORDER_IS_READY",     // Keep (correct)
        "Dispatched": "WAITING_FOR_PICKUP", // Keep (correct)
        "Delivered": "DELIVERED"          // ← CHANGE to DELIVERED
      };


      const apiStatus = statusMap[newStatus];
      const note = "Updated from order lifecycle";

      if (itemIds.length === 0) {
        alert("No items selected");
        return false;
      }

      // Join itemIds for batch update
      const itemIdsParam = itemIds.join("&itemIds=");
      const url = `https://backend.maamaas.com/food/api/cart/cart/status/${cartId}?itemIds=${itemIdsParam}&status=${apiStatus}&note=${encodeURIComponent(note)}`;

      const response = await fetch(url, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Error ${response.status}: ${errorText}`);
      }

      const data = await response.json();
      return true;
    } catch (error) {
      console.error(`Failed to update dine-in items status to ${newStatus}:`, error);
      alert(`Failed to update dine-in items: ${error.message}`);
      return false;
    }
  };

  // 7. Function to handle stage click
  // 7. Function to handle stage click - MODIFIED VERSION
  const handleStageClick = async (order, stage, stageIndex) => {
    const orderId = order.orderId || order.cartId;

    // Don't allow clicking on already completed stages
    const stageOrder = ["Placed", "Preparing", "Prepared", "Dispatched", "Delivered"];
    const currentStageIndex = getCurrentStageIndex(order);

    // PREVENT GOING BACK: Check if stage is already completed
    if (stageIndex <= currentStageIndex) {
      return; // Already completed or current stage, no action
    }

    // ✅ REMOVED: The check for sequential progression
    // if (stageIndex !== currentStageIndex + 1) {
    //   const nextStage = stageOrder[currentStageIndex + 1];
    //   alert(`Please complete "${nextStage}" stage first!`);
    //   return;
    // }

    // Show confirmation
    // const confirmMessage = order.orderType === "TABLE_DINE_IN"
    //   ? `Mark ${getSelectedDineInItemIds(order).length} selected items as "${stage}"?`
    //   : `Mark order #${orderId} as "${stage}"?`;

    // if (!window.confirm(confirmMessage)) {
    //   return;
    // }

    let success = false;

    // For TABLE_DINE_IN orders with selected items
    if (order.orderType === "TABLE_DINE_IN") {
      const selectedItemIds = getSelectedDineInItemIds(order);
      if (selectedItemIds.length === 0) {
        alert("Please select at least one item to update");
        return;
      }

      success = await updateDineInItemsStatus(order.cartId, selectedItemIds, stage);
    } else {
      // For normal orders
      success = await updateOrderStatus(orderId, stage);
    }

    if (success) {
      // Refresh orders after short delay
      setTimeout(() => {
        fetchOrders();
      }, 500);
    }
  };
  // Separate function to export ALL orders
  const exportAllOrdersForCSV = async () => {
    if (!vendorId) {
      alert("No vendor ID found");
      return;
    }

    showLoader();
    try {
      const token = localStorage.getItem("authToken");

      // Fetch ALL orders for export (not paginated)
      const response = await axios.get(
        `https://backend.maamaas.com/food/api/orders/vendor/${vendorId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      let allOrders = response.data || [];

      // Apply date filter if selected
      if (selectedDate) {
        allOrders = allOrders.filter(order => {
          if (!order.orderDateAndTime) return false;
          const orderDate = new Date(order.orderDateAndTime).toISOString().split('T')[0];
          return orderDate === selectedDate;
        });
      }

      if (allOrders.length === 0) {
        alert("No data to export!");
        hideLoader();
        return;
      }

      // Build CSV with username column
      const headers = ["S.No", "Order ID", "User Name", "Date", "Category", "Type", "Payment", "Order Status", "Amount"];

      const rows = allOrders.map((item, index) => [
        index + 1,
        item.orderId,
        item.userName || "Guest", // Add username here
        new Date(item.orderDateAndTime).toLocaleDateString("en-GB"),
        "Food",
        item.orderType || item.orderService,
        item.paymentMethod === "Online_Payment" ? "Online" : item.paymentMethod,
        item.status,
        Math.round(item.grandTotal || 0),
      ]);

      // Format CSV for Excel compatibility
      const formatCell = (cell) => {
        if (cell === null || cell === undefined) return '""';
        const cellStr = String(cell);

        // Escape double quotes by doubling them
        const escaped = cellStr.replace(/"/g, '""');

        // Wrap in quotes if contains comma, quotes, or newline
        if (cellStr.includes(',') || cellStr.includes('"') || cellStr.includes('\n') || cellStr.includes('\r')) {
          return `"${escaped}"`;
        }
        return escaped;
      };

      // Create CSV lines
      const csvLines = [headers, ...rows]
        .map(row => row.map(cell => formatCell(cell)).join(','));

      // Add BOM (Byte Order Mark) for UTF-8 Excel compatibility
      const BOM = '\uFEFF';
      const csvContent = BOM + csvLines.join('\r\n'); // Use \r\n for Windows compatibility

      // Create blob with proper MIME type
      const blob = new Blob([csvContent], {
        type: 'text/csv; charset=utf-8;'
      });

      // Create download link
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');

      // Use .csv extension but format it for Excel
      const fileName = `Orders_${selectedDate || 'All'}_${new Date().toISOString().split('T')[0]}.csv`;

      link.href = url;
      link.setAttribute('download', fileName);
      link.style.visibility = 'hidden';

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Clean up
      setTimeout(() => URL.revokeObjectURL(url), 100);

      // Optional: Show success message

    } catch (error) {
      console.error("Export error:", error);
      alert("Failed to export data. Please try again.");
    } finally {
      hideLoader();
    }
  };
  const [showDetails, setShowDetails] = useState(false);

  const orderStages = ["Placed", "Preparing", "Prepared", "Dispatched", "Delivered"];

  const styles = {
    card: { border: '1px solid #ccc', padding: '16px', margin: '16px', marginRight: "0px", marginLeft: "0px", borderRadius: '10px', background: "linear-gradient(to right, #f46b45, #eea849)", },
    header: { display: 'flex', justifyContent: 'space-around', },
    orderId: { margin: 0, fontWeight: "bold" },
    date: { fontSize: '18px', color: '#000', fontWeight: "bold" },
    pickupBtn: { background: '#28a745', color: '#fff', border: 'none', padding: '6px 12px', cursor: 'pointer', borderRadius: '5px', fontWeight: "bold", },
    tracker: { marginTop: '10px', display: 'flex', alignItems: 'center', fontWeight: "bold" },
    statusBox: { background: '#eee', padding: '8px 12px', borderRadius: '5px' },
    arrow: { margin: '0 5px' },
    dropdownBtn: {
      background: 'none',
      border: 'none',
      fontSize: '20px',
      cursor: 'pointer',
      ...(screenWidth >= 1000 && screenWidth <= 1200 ? { marginLeft: '100px' } : {}), // 👈 conditional style
    },
    itemList: { marginTop: '10px', fontWeight: "bold" },
    itemRow: { display: 'flex', justifyContent: 'space-between', padding: '4px 0', borderBottom: '1px solid #ddd' }
  };
  // Helper function to get status color
  const getStatusColor = (status) => {
    const statusColors = {
      CONFIRMED: '#607d8b',          // Orange
      PROCESSING: '#607d8b',         // Blue
      BEING_PREPARED: '#607d8b',     // Green
      ORDER_IS_READY: '#607d8b',     // Purple
      WAITING_FOR_PICKUP: '#607d8b', // Gray
      COMPLETED: '#607d8b',          // Brown
    };
    return statusColors[status] || '#666';
  };

  // Helper function to get status text
  const getStatusText = (status) => {
    const statusTexts = {
      CONFIRMED: "Confirmed",
      PROCESSING: "Placed",
      BEING_PREPARED: "Preparing",
      ORDER_IS_READY: "Prepared",
      WAITING_FOR_PICKUP: "Dispatched",
      COMPLETED: "Delivered",
    };
    return statusTexts[status] || "Processing";
  };


  // Function to fetch order details for receipt


  const [printOrderData, setPrintOrderData] = useState({});

  // Add this function near your other functions (like fetchPaginatedOrders)
  const handlePrintReceipt = async (order) => {
    setIsPrinting(true);
    setPrintingOrderId(order.orderId);

    try {
      const token = localStorage.getItem("authToken");

      // Fetch order details - try both endpoints
      let orderDetails = null;

      try {
        // Try the same endpoint as your cart file
        const response = await axios.get(
          `https://backend.maamaas.com/food/api/orders/order/${order.orderId}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        orderDetails = response.data;
      } catch (err1) {
        try {
          const response = await axios.get(
            `https://backend.maamaas.com/food/api/orders/get/${order.orderId}`,
            { headers: { Authorization: `Bearer ${token}` } }
          );
          orderDetails = response.data;
        } catch (err2) {
          console.error("Both endpoints failed:", err1, err2);
          throw new Error("Could not fetch order details");
        }
      }

      // Set print order data
      setPrintOrderData(orderDetails);

      // Create receipt HTML using YOUR EXACT handlePrint logic
      const printStyles = `
<style>
@media print {
    body {
        width: 80mm !important;
        margin: 0 auto !important;
        padding: 0 !important;
        font-family: "Courier New", monospace !important;
        font-size: 12px !important;
        line-height: 1.25 !important;
        font-weight: 700 !important;
    }

    h1, h2, h3 {
        font-weight: 800;
        text-align: center;
        margin: 0;
        padding: 0;
        font-size: 16px !important;
    }

    .big-title {
        font-size: 16px !important;
        font-weight: 800;
        text-align: center;
        margin-bottom: 6px;
    }

    .center-text {
        text-align: center;
        font-size: 12px !important;
        font-weight: 700;
    }

    .line {
        border-top: 1px solid black;
        margin: 7px 0;
    }

    .dashed {
        border-top: 1px dashed black;
        margin: 7px 0;
    }

    table {
        width: 100%;
        font-size: 12px !important;
        border-collapse: collapse;
    }

    th {
        padding: 2px 0px;
        font-weight: 800;
        font-size: 12px !important;
    }

    td {
        padding: 3px 0px;
        font-weight: 600;
        font-size: 12px !important;
    }

    .row {
        display: flex;
        justify-content: space-around;
        font-size: 12px !important;
        font-weight: 700;
        white-space: nowrap;
        width: 100%;
    }

    .grand-label,
    .grand-value {
        font-size: 18px !important;
        font-weight: 800;
    }

    .footer {
        text-align: center;
        margin-top: 12px;
        font-size: 12px !important;
        font-weight: 700;
    }

    .receipt-buttons, button {
        display: none !important;
    }

    @page {
        size: 80mm auto;
        margin: 0;
    }

    .page-break {
        page-break-after: always;
    }
}
</style>
`;

      // Get vendor details for GSTIN/FSSAI
      const vendorId = localStorage.getItem("vendorId");
      let vendorGstIn = "N/A";
      let vendorFssai = "23624032003384";

      try {
        const vendorResponse = await axios.get(
          `https://backend.maamaas.com/food/api/vendors/${vendorId}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        vendorGstIn = vendorResponse.data?.gstNumber || "N/A";
        vendorFssai = vendorResponse.data?.fssaiNumber || "23624032003384";
      } catch (vendorErr) {
      }

      // Format date and time
      const formatDate = (dateString) => {
        try {
          const date = new Date(dateString);
          return date.toLocaleDateString('en-GB');
        } catch {
          return new Date().toLocaleDateString('en-GB');
        }
      };

      const formatTime = (dateString) => {
        try {
          const date = new Date(dateString);
          return date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true });
        } catch {
          return new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true });
        }
      };

      // SIMPLE RECEIPT (Top Image) - HARDCODED "Take A Break" - SAME AS YOUR CART
      const receiptOne = `
        <div class="big-title">Take A Break</div>
        <div class="line"></div>

        <div class="row"><span>OrderID: ${orderDetails.orderId}</span><span>Date: ${orderDetails.date || formatDate(orderDetails.orderDateAndTime)}</span></div>
        <div class="row"><span>Type: ${orderDetails.orderType || "Dine In"}</span><span>Time: ${orderDetails.time || formatTime(orderDetails.orderDateAndTime)}</span></div>

        <div class="center-text">Payment: ${orderDetails.paymentMethod || "Cash"}</div>

        <div class="line"></div>

        <table>
            <thead>
                <tr>
                    <th style="text-align:center;">Item</th>
                    <th style="text-align:center;">Qty</th>
                </tr>
            </thead>
            <tbody>
                ${Array.isArray(orderDetails.order) ? orderDetails.order.map(item => `
                    <tr>
                        <td style="text-align:center;">${item.dishName || "Item"}</td>
                        <td style="text-align:center;">${item.quantity || 1}</td>
                    </tr>
                `).join("") : ""}
            </tbody>
        </table>

        <div class="line"></div>
    `;

      // DETAILED RECEIPT (Bottom Image) - HARDCODED "Take A Break" - SAME AS YOUR CART
      const receiptTwo = `
        <div class="big-title">Take A Break</div>
        <div class="center-text">GSTIN: ${vendorGstIn}</div>
        <div class="line"></div>

        <div class="row"><span>OrderID: ${orderDetails.orderId}</span><span>Date: ${orderDetails.date || formatDate(orderDetails.orderDateAndTime)}</span></div>
        <div class="row"><span>Type: ${orderDetails.orderType || "Dine In"}</span><span>Time: ${orderDetails.time || formatTime(orderDetails.orderDateAndTime)}</span></div>
        <div class="center-text">Payment: ${orderDetails.paymentMethod || "Cash"}</div>

        <div class="line"></div>

        <table class="items-table">
            <thead>
                <tr>
                    <th style="text-align:center;">Item</th>
                    <th style="text-align:center;">Qty</th>
                    <th style="text-align:center;">Price</th>
                    <th style="text-align:center;">Total</th>
                </tr>
            </thead>
            <tbody>
    ${Array.isArray(orderDetails.order) ? orderDetails.order.map(item => `
        <tr>
            <td style="text-align:center;"><b>${item.dishName || "Item"}</b></td>
            <td style="text-align:center;"><b>${item.quantity || 1}</b></td>
            <td style="text-align:center;"><b>₹${(item.price || 0).toFixed(2)}</b></td>
            <td style="text-align:center;"><b>₹${((item.price || 0) * (item.quantity || 1)).toFixed(2)}</b></td>
        </tr>
    `).join("") : ""}
</tbody>

        </table>

        <div class="line"></div>

        <div class="row"><span>SubTotal</span><span>₹${(orderDetails.subTotal || 0).toFixed(2)}</span></div>
        <div class="row"><span>Platform</span><span>₹${(orderDetails.platformCharges || 0).toFixed(2)}</span></div>
        <div class="row"><span>Service</span><span>₹${(orderDetails.serviceCharge || 0).toFixed(2)}</span></div>
        <div class="row"><span>CGST</span><span>₹${(orderDetails.cgst || 0).toFixed(2)}</span></div>
        <div class="row"><span>SGST</span><span>₹${(orderDetails.sgst || 0).toFixed(2)}</span></div>

        <div class="line"></div>

        <div class="row">
            <span class="grand-label">Grand Total</span>
            <span class="grand-value">₹${(orderDetails.grandTotal || 0).toFixed(2)}</span>
        </div>

        <div class="dashed"></div>
        <div class="center-text">FSSAI: ${vendorFssai}</div>

        <div class="footer">
            Thank you, visit again<br/>
            www.maamaas.com
        </div>
    `;

      // FINAL PRINT CONTENT - SAME FORMAT AS YOUR CART
      const finalHTML = `
        <!DOCTYPE html>
        <html>
        <head>
            <title>Receipt - ${orderDetails.orderId || 'Order'}</title>
            ${printStyles}
        </head>
        <body>
            ${receiptOne}
            <div class="page-break"></div>
            ${receiptTwo}
        </body>
        </html>
    `;

      // Open print window - SAME LOGIC AS YOUR CART
      const printWindow = window.open('', '_blank', 'width=800,height=600');

      if (!printWindow) {
        alert("Please allow pop-ups to print receipt");
        throw new Error("Popup blocked");
      }

      printWindow.document.open();
      printWindow.document.write(finalHTML);
      printWindow.document.close();

      printWindow.onload = () => {
        printWindow.print();

        // Listen for afterprint event
        printWindow.onafterprint = () => {
          setTimeout(() => {
            printWindow.close();
          }, 500);
        };

        // Fallback in case afterprint doesn't fire
        setTimeout(() => {
          if (printWindow && !printWindow.closed) {
            printWindow.close();
          }
        }, 3000);
      };

      setTimeout(() => {
        if (printWindow && !printWindow.closed) {
          printWindow.close();
        }
      }, 1000);

    } catch (error) {
      console.error("Print error:", error);

      if (error.message.includes("Popup blocked")) {
        alert("Please allow pop-ups in your browser to print receipts.");
      } else {
        alert("Failed to print receipt. Error: " + error.message);
      }
    } finally {
      setIsPrinting(false);
      setPrintingOrderId(null);
    }
  };

  // Helper function to get status text - UPDATE THIS FUNCTION
  const getStatusTextt = (status) => {
    const statusTexts = {
      CONFIRMED: "Placed",
      PROCESSING: "Preparing",
      BEING_PREPARED: "Preparing", // Map to same as PROCESSING
      ORDER_IS_READY: "Prepared",
      WAITING_FOR_PICKUP: "Dispatched",
      DELIVERED: "Delivered",
      COMPLETED: "Delivered", // Map to same as DELIVERED
      PENDING: "Placed",
      ACCEPTED: "Placed",
      REJECTED: "Cancelled",
      CANCELLED: "Cancelled",
    };
    return statusTexts[status] || status;
  };

  // Helper function to get status color - UPDATE THIS TOO
  const getStatusColorr = (status) => {
    const statusColors = {
      CONFIRMED: '#607d8b',          // Gray - Placed
      PROCESSING: '#2196F3',         // Blue - Preparing
      BEING_PREPARED: '#2196F3',     // Blue - Preparing
      ORDER_IS_READY: '#9C27B0',     // Purple - Prepared
      WAITING_FOR_PICKUP: '#FF9800', // Orange - Dispatched
      DELIVERED: '#4CAF50',          // Green - Delivered
      COMPLETED: '#4CAF50',          // Green - Delivered
      PENDING: '#607d8b',            // Gray - Placed
      ACCEPTED: '#607d8b',           // Gray - Placed
      REJECTED: '#f44336',           // Red - Cancelled
      CANCELLED: '#f44336',          // Red - Cancelled
    };
    return statusColors[status] || '#666';
  };
  useEffect(() => {
    // Reset to first page when search query changes
    setCurrentPage(0);
  }, [searchQuery]);

  // Helper function to format schedule date and time
  const formatScheduleDateTime = (order) => {
    if (!order.date || !order.time) return "N/A";

    try {
      // Format date
      const dateObj = new Date(order.date);
      const formattedDate = dateObj.toLocaleDateString('en-IN', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
      });

      // Format time
      const formattedTime = formatTime(order.time);

      return `${formattedDate} ${formattedTime}`;
    } catch (e) {
      console.error("Error formatting schedule date/time:", e);
      return "N/A";
    }
  };

  // Helper function to format time (if not already present)
  const formatTime = (timeString) => {
    if (!timeString) return "N/A";
    try {
      if (timeString.includes(':')) {
        const [hours, minutes] = timeString.split(':');
        const hour = parseInt(hours);
        const ampm = hour >= 12 ? 'PM' : 'AM';
        const displayHour = hour % 12 || 12;
        return `${displayHour}:${minutes} ${ampm}`;
      }
      return timeString;
    } catch (e) {
      return timeString;
    }
  };

  // NEW FUNCTION: Handle global search by Order ID
  // In the Standardorder component, replace the handleGlobalSearch function:

  // NEW FUNCTION: Handle global search by Order ID - shows result as card
  const handleGlobalSearch = async () => {
    if (!globalSearchQuery.trim()) {
      setSearchResult(null);
      setShowSearchResult(false);
      return;
    }

    setIsSearching(true);
    const token = localStorage.getItem("authToken");

    try {
      // Use the order API to search by Order ID
      const response = await axios.get(
        `https://backend.maamaas.com/food/api/orders/order/${globalSearchQuery.trim()}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      const order = response.data;
      if (order) {
        // For DELIVERY/TAKEAWAY orders, try to fetch OTP from delivery API
        if (order.orderType === "DELIVERY" || order.orderType === "TAKEAWAY") {
          try {
            const deliveryResponse = await axios.get(
              `https://backend.maamaas.com/delivery/api/get/order`,
              {
                params: {
                  orderId: order.orderId,
                  appType: "FOOD_AND_BEVERAGES"
                },
                headers: { Authorization: `Bearer ${token}` }
              }
            );

            // Merge delivery data into order
            order.vendorOtp = deliveryResponse.data?.vendorOtp;
            order.userOtp = deliveryResponse.data?.userOtp;
            order.deliveryAddress = deliveryResponse.data?.deliveryAddress || order.deliveryAddress;
            order.deliveryStatus = deliveryResponse.data?.status;
          } catch (deliveryError) {
            console.warn(`Delivery API failed for order ${order.orderId}:`, deliveryError.message);
            // Keep original order data if delivery API fails
          }
        }

        setSearchResult(order);
        setShowSearchResult(true);

        // DO NOT switch to Status tab - keep in current tab
        // setActiveTab('Status');

        // Also update the Status tab with this single order (for if user manually switches)
        // setStatusOrders([order]);
        // setCurrentPage(0);
        // setTotalPages(1);

      } else {
        setSearchResult(null);
        alert(`No order found with ID: ${globalSearchQuery}`);
      }
    } catch (error) {
      console.error("Search error:", error);
      setSearchResult(null);
      // alert(`Error searching for order: ${error.response?.data?.message || error.message}`);
    } finally {
      setIsSearching(false);
    }
  };

  // Also update the clearGlobalSearch function:
  const clearGlobalSearch = () => {
    setGlobalSearchQuery('');
    setSearchResult(null);
    setShowSearchResult(false);
    // DO NOT refresh orders - let the current view stay
    // if (vendorId) {
    //   fetchOrders();
    // }
  };



  // Handle Enter key press in search
  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleGlobalSearch();
    }
  };

  // Helper function to render layout with Orders component
  const renderWithOrdersSidebar = (mainContent) => (
    <div style={{
      display: 'flex',
      gap: '20px',
      height: '100%',
      width: '100%'
    }}>
      {/* Main Content - Takes 9 columns */}
      <div style={{
        flex: '0 0 100%', // col-lg-9
        maxWidth: '100%',
        overflow: 'auto'
      }}>
        {mainContent}
      </div>

      {/* Orders Sidebar - Takes 3 columns */}
      <div style={{
        flex: '0 0 0%', // col-lg-3
        maxWidth: '25%',
        position: 'sticky',
        top: 0,
        height: 'fit-content',
        maxHeight: 'calc(100vh - 200px)',
        overflowY: 'auto',
        borderRadius: '10px',
        padding: '10px'
      }}>
        {/* <Orders /> */}
      </div>
    </div>
  );


  // {=======================overview===============================}
  const tabContent = {
    // In the Standardorder component, update the tabContent for "Order Life-Cycle":
    Products: (<Menudatas />),

    Status: renderWithOrdersSidebar(
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        overflow: 'hidden', // Prevent overall scrolling
      }}>
        {/* FIXED SEARCH BAR */}
        <div style={{
          flexShrink: 0, // Don't shrink
          padding: '5px 0',
          backgroundColor: 'white',
          zIndex: 100,
          position: 'sticky',
          top: 0,
          width: '97%',
          paddingTop: "0px",
          paddingBottom: "10px"
        }}>
          <div style={{
            display: 'flex',
            justifyContent: 'end',
            width: '100%'
          }}>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '10px',
              width: window.innerWidth < 500 ? '90%' : window.innerWidth < 768 ? '50%' : '40%',
              maxWidth: '600px',
              position: 'relative'
            }}>
              {/* Search input */}
              <div style={{
                flex: 1,
                position: 'relative'
              }}>
                <input
                  type="text"
                  value={globalSearchQuery}
                  onChange={(e) => setGlobalSearchQuery(e.target.value)}
                  onKeyPress={handleKeyPress}
                  placeholder="Search Order by ID..."
                  style={{
                    width: '100%',
                    padding: '5px 10px 5px 10px',
                    border: '2px solid hsl(0, 0%, 87%)',
                    borderRadius: '5px',
                    fontSize: '14px',
                    outline: 'none',
                    boxShadow: '0 2px 8px rgba(177, 92, 214, 0.2)',
                    transition: 'all 0.3s ease'
                  }}
                />

              </div>

              {/* Search button */}
              <button
                onClick={handleGlobalSearch}
                disabled={isSearching || !globalSearchQuery.trim()}
                style={{
                  padding: '5px 10px',
                  backgroundColor: isSearching ? '#ccc' : '#b15cd6',
                  color: 'white',
                  border: 'none',
                  borderRadius: '20px',
                  fontWeight: '500',
                  cursor: isSearching || !globalSearchQuery.trim() ? 'not-allowed' : 'pointer',
                  whiteSpace: 'nowrap',
                  fontSize: '16px',
                  transition: 'all 0.3s ease',
                  // marginRight:"10%",
                }}
              >
                {isSearching ? 'Searching...' : 'Search'}
              </button>

              {/* Clear button (only when there's search query) */}
              {globalSearchQuery && (
                <button
                  onClick={clearGlobalSearch}
                  style={{
                    padding: '5px 10px',
                    backgroundColor: '#f44336',
                    color: 'white',
                    border: 'none',
                    borderRadius: '25px',
                    fontWeight: 'bold',
                    cursor: 'pointer',
                    fontSize: '14px'
                  }}
                >
                  Clear
                </button>
              )}
            </div>
          </div>
        </div>

        {/* SCROLLABLE CARDS AREA */}
        <div style={{
          flex: 1,
          overflowY: 'auto',
          overflowX: 'hidden',
          scrollbarWidth: 'thin',
          msOverflowStyle: 'none',
          WebkitOverflowScrolling: 'touch',
          padding: '0 16px',
          paddingRight: "0px",
          paddingBottom: '0px'
        }}>
          {/* Custom scrollbar styling */}
          <style>
            {`
          /* Webkit browsers (Chrome, Safari) */
          .scrollable-cards::-webkit-scrollbar {
            width: 6px;
          }
          .scrollable-cards::-webkit-scrollbar-track {
            background: #f1f1f1;
            border-radius: 3px;
          }
          .scrollable-cards::-webkit-scrollbar-thumb {
            background: #b15cd6;
            border-radius: 3px;
          }
          .scrollable-cards::-webkit-scrollbar-thumb:hover {
            background: #9a4bc2;
          }
          /* Firefox */
          .scrollable-cards {
            scrollbar-width: thin;
            scrollbar-color: #b15cd6 #f1f1f1;
          }
        `}
          </style>

          {/* SEARCH RESULT OR FILTERED ORDERS */}
          {(() => {
            // Filter orders based on search query
            let ordersToDisplay = orders;

            if (globalSearchQuery.trim()) {
              // If search result exists, show only that
              if (searchResult) {
                ordersToDisplay = [searchResult];
              } else {
                // If searching but no result yet, show loading or nothing
                return (
                  <div style={{
                    textAlign: 'center',
                    padding: '60px 20px',
                    color: '#666',
                    fontSize: '16px',
                    borderRadius: '10px',
                    marginTop: '20px'
                  }}>
                    {isSearching ? (
                      <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        gap: '15px'
                      }}>
                        <div style={{
                          width: '40px',
                          height: '40px',
                          border: '3px solid rgb(243, 243, 243)',
                          borderTop: '3px solid #b15cd6',
                          borderRadius: '50%',
                          animation: 'spin 1s linear infinite'
                        }}></div>
                        <span>Searching for order #{globalSearchQuery}...</span>
                      </div>
                    ) : 'No orders found'}
                  </div>
                );
              }
            }

            // Show orders (either all or filtered)
            if (ordersToDisplay.length === 0) {
              return (
                <div style={{
                  textAlign: 'center',
                  padding: '60px 20px',
                  color: '#666',
                  fontSize: '16px',
                  borderRadius: '10px',
                  marginTop: '20px'
                }}>
                  Loading ...
                </div>
              );
            }

            return (
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '16px',
                padding: '10px 0',
                paddingTop: "0px",
              }}>
                {ordersToDisplay.map((order) => {
                  // For TABLE_DINE_IN orders, use cartItems; otherwise use orderItems
                  const orderItems = order.orderType === "TABLE_DINE_IN" ? order.cartItems || [] : order.order || [];
                  const orderId = order.orderId || order.cartId; // fallback for TABLE_DINE_IN
                  const selected = selectedItems[orderId] || [];

                  return (
                    <div key={orderId} style={{
                      border: '1px solid #ccc',
                      padding: '10px',
                      borderRadius: '10px',
                      background: (() => {
                        const normalized = (order.orderType || "").trim().toLowerCase();
                        switch (normalized) {
                          case "dine_in": return "#1E90FF";
                          case "takeaway": return "#FF6347";
                          case "delivery": return "#20B2AA";
                          case "table_dine_in": return "#2051b2ff";
                          default: return "#b15cd6";
                        }
                      })(),
                      boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                      transition: 'transform 0.2s ease, box-shadow 0.2s ease'
                    }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'translateY(-2px)';
                        e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'translateY(0)';
                        e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.1)';
                      }}>
                      <div style={styles.header}>
                        {/* Main container with responsive layout */}
                        <div style={{
                          display: 'flex',
                          flexDirection: window.innerWidth < 1300 ? 'column' : 'row',
                          justifyContent: 'space-between',
                          alignItems: window.innerWidth < 1300 ? 'stretch' : 'center',
                          gap: window.innerWidth < 1300 ? '10px' : '0',
                          width: '100%',
                          padding: '5px 0',
                        }}>

                          {/* First Line: Order ID and Date/Time - Full width with space-between */}
                          <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: window.innerWidth <= 500 ? 'start' : 'center',
                            width: '100%',
                            flexDirection: window.innerWidth <= 500 ? "column" : "row",
                            marginLeft: window.innerWidth <= 370 ? "-1rem" : " ",
                            gap: window.innerWidth <= 769 ? '0px' : '10px',
                            padding: window.innerWidth < 1300 ? '0 5px' : '0',
                          }}>
                            <div style={{
                              ...styles.orderId,
                              margin: 0,
                              fontSize: window.innerWidth <= 370 ? '14px' : '17px',
                              fontWeight: 'bold',
                              color: "black",
                              whiteSpace: 'nowrap',
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              width: "100%",
                            }}>
                              {/* Left side - Order ID */}
                              <div style={{
                                flex: "0 0 auto",
                                fontSize: window.inner < 769 ? "15px" : "16px"
                              }}>
                                ORDER ID : <span style={{
                                  fontWeight: "bold",
                                  fontSize: window.innerWidth <= 500 ? "1rem" : "1.3rem",
                                  color: "white"
                                }}>#{orderId}</span>
                              </div>

                              {/* Right side - Order Type button */}
                              <div style={{
                                flex: "0 0 auto",
                                marginLeft: "10px",
                              }}>
                                <button style={{
                                  background: '#28a745',
                                  color: '#fff',
                                  border: 'none',
                                  padding: window.innerWidth < 1100 ? "5px 10px" : '6px 15px',
                                  borderRadius: '4px',
                                  fontWeight: 'bold',
                                  fontSize: '14px',
                                  whiteSpace: 'nowrap',
                                  cursor: 'default',
                                  display: window.innerWidth <= 450 ? "block" : "none",
                                }}>
                                  {order.orderType === 'DINE_IN' ? 'DINEIN' : (order.service || order.orderType || 'Service')}
                                </button>
                              </div>
                            </div>

                            {/* Date and Time inline */}
                            {order.orderDateAndTime && (
                              <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                fontSize: window.innerWidth <= 370 ? '14px' : '16px',
                                color: '#000000ff',
                                fontWeight: '500',
                                whiteSpace: 'nowrap',
                              }}>
                                <span style={{ whiteSpace: 'nowrap' }}>
                                  {(() => {
                                    const dateObj = new Date(order.orderDateAndTime);
                                    const date = dateObj.toLocaleDateString('en-IN', {
                                      day: '2-digit',
                                      month: 'short',
                                      year: 'numeric',
                                    });
                                    const time = dateObj.toLocaleTimeString('en-IN', {
                                      hour: '2-digit',
                                      minute: '2-digit',
                                      hour12: true,
                                    });
                                    return (
                                      <>
                                        <span style={{ color: '#000000ff', fontWeight: 'bold', fontSize: window.innerWidth <= 769 ? '15px' : '16px', }}>DATE:</span>
                                        <span style={{ color: '#ffffffff', marginRight: '10px', marginLeft: "5px", fontSize: window.innerWidth <= 500 ? "1rem" : "1.3rem" }}>{date}</span>
                                        <span style={{ color: '#000000ff', fontWeight: 'bold', fontSize: window.innerWidth <= 769 ? '14px' : '16px', }}>TIME:</span>
                                        <span style={{ color: '#ffffffff', marginLeft: "5px", fontSize: window.innerWidth <= 500 ? "1rem" : "1.3rem" }}>{time}</span>
                                      </>
                                    );
                                  })()}
                                </span>



                                <button
                                  style={{
                                    background: 'none',
                                    border: '0px solid #ccc',
                                    borderRadius: '4px',
                                    padding: '6px 12px',
                                    cursor: 'pointer',
                                    fontSize: '14px',
                                    minWidth: '40px',
                                    display: window.innerWidth > 1299 ? "none" : "block",
                                  }}
                                  onClick={() =>
                                    setShowDetails((prev) => ({
                                      ...prev,
                                      [orderId]: !prev[orderId],
                                    }))
                                  }
                                >
                                  {showDetails[orderId] ? '▲' : '▼'}
                                </button>
                              </div>
                            )}
                          </div>

                          {/* Second Line: Order Type, Status, and Dropdown - Aligned to end */}
                          <div style={{
                            display: 'flex',
                            justifyContent: window.innerWidth < 1300 ? 'flex-end' : 'end',
                            alignItems: 'center',
                            gap: window.innerWidth >= 1300 && window.innerWidth < 1350 ? '5px' : '10px',
                            width: '100%',
                            padding: window.innerWidth < 1300 ? '5px 5px 0 5px' : '0',
                            flexWrap: 'nowrap',
                          }}>

                            {/* ✅ OTP DISPLAY FOR DELIVERY/TAKEAWAY ORDERS */}
                            {(order.orderType === "DELIVERY" || order.orderType === "TAKEAWAY") && order.vendorOtp && (
                              <div style={{
                                marginLeft: '10px',
                                fontSize: window.innerWidth <= 500 ? "14px" : "16px",
                                fontWeight: "bold",
                                color: "#fff",
                                background: "#00000066",
                                padding: "4px 10px",
                                borderRadius: "6px",
                                whiteSpace: "nowrap"
                              }}>
                                OTP: <span style={{ color: "#FFD700" }}>{order.vendorOtp}</span>
                              </div>
                            )}
                            {/* Order Type */}
                            <div style={{
                              display: 'flex',
                              alignItems: 'center',
                            }}>
                              <button style={{
                                background: '#28a745',
                                color: '#fff',
                                border: 'none',
                                padding: window.innerWidth < 1100 ? "5px 10px" : '6px 15px',
                                borderRadius: '4px',
                                fontWeight: 'bold',
                                fontSize: '14px',
                                whiteSpace: 'nowrap',
                                cursor: 'default',
                                display: window.innerWidth > 450 ? "block" : "none",
                              }}>
                                {order.orderType === 'DINE_IN' ? 'DINEIN' : (order.service || order.orderType || 'Service')}
                              </button>
                            </div>

                            {/* Status indicator */}
                            <div style={{
                              padding: '6px 12px',
                              backgroundColor: getStatusColor(order.status),
                              color: 'white',
                              borderRadius: '4px',
                              fontSize: '14px',
                              textTransform: 'uppercase',
                              whiteSpace: 'nowrap',
                              minWidth: '100px',
                              textAlign: 'center',
                              display: window.innerWidth > 450 ? "block" : "none",
                            }}>
                              {getStatusText(order.status)}
                            </div>

                            {/* Dropdown button */}
                            <button
                              style={{
                                background: 'none',
                                border: '0px solid #ccc',
                                borderRadius: '4px',
                                padding: '6px 12px',
                                cursor: 'pointer',
                                fontSize: '14px',
                                minWidth: '35px',
                                display: window.innerWidth > 1299 ? "block" : "none",
                              }}
                              onClick={() =>
                                setShowDetails((prev) => ({
                                  ...prev,
                                  [orderId]: !prev[orderId],
                                }))
                              }
                            >
                              {showDetails[orderId] ? '▲' : '▼'}
                            </button>
                          </div>
                        </div>
                      </div>

                      {showDetails[orderId] && (
                        <>
                          <div style={{
                            marginTop: window.innerWidth < 450 ? '-1rem' : '0rem',
                            margin: window.innerWidth < 500 ? "0px 0%" : window.innerWidth >= 1200 ? " 0px 2%" : "0px 0%",
                            paddingTop: '10px'
                          }}>
                            {/* Fixed height container for table scrolling */}
                            <div style={{
                              width: '100%',
                              maxHeight: window.innerWidth <= 768 ? '350px' : 'auto',
                              overflow: window.innerWidth <= 768 ? 'auto' : 'visible',
                              overflowX: window.innerWidth <= 768 ? 'auto' : 'visible',
                              overflowY: window.innerWidth <= 768 ? 'hidden' : 'visible',
                              WebkitOverflowScrolling: 'touch',
                              position: 'relative',
                              scrollbarWidth: 'thin',
                              msOverflowStyle: 'none',
                              borderRadius: '8px',
                              border: window.innerWidth <= 768 ? '2px solid #b15cd6' : 'none'
                            }}>
                              {/* Traditional Table */}
                              <table style={{
                                width: window.innerWidth <= 768 ? 'max-content' : '100%',
                                minWidth: window.innerWidth <= 768 ? '650px' : '100%',
                                borderCollapse: 'collapse',
                                border: window.innerWidth <= 768 ? 'none' : '2px solid #b15cd6',
                                background: 'transparent',
                                borderRadius: window.innerWidth <= 768 ? '0' : '8px',
                                overflow: 'hidden',
                                boxShadow: window.innerWidth <= 768 ? 'none' : '0 4px 12px rgba(0, 0, 0, 0.1)'
                              }}>
                                {/* HEADER ROW */}
                                <thead>
                                  <tr style={{
                                    background: '#b15cd6',
                                    borderBottom: '2px solid #9a4bc2',
                                    position: window.innerWidth <= 768 ? 'sticky' : 'static',
                                    top: 0,
                                    left: 0,
                                    zIndex: 10
                                  }}>
                                    <th style={{
                                      textAlign: 'center',
                                      color: 'Black',
                                      fontWeight: 'bold',
                                      fontSize: window.innerWidth <= 370 ? '12px' : window.innerWidth <= 768 ? '13px' : '14px',
                                      padding: window.innerWidth <= 768 ? '10px 8px' : '12px 8px',
                                      borderRight: '1px solid rgba(255, 255, 255, 0.3)',
                                      minWidth: '120px',
                                      position: 'sticky',
                                      left: 0,
                                      background: '#b15cd6',
                                      zIndex: 11
                                    }}>
                                      Name
                                    </th>
                                    <th style={{
                                      textAlign: 'center',
                                      color: 'Black',
                                      fontWeight: 'bold',
                                      fontSize: window.innerWidth <= 370 ? '12px' : window.innerWidth <= 768 ? '13px' : '14px',
                                      padding: window.innerWidth <= 768 ? '10px 8px' : '12px 8px',
                                      borderRight: '1px solid rgba(255, 255, 255, 0.3)',
                                      minWidth: '120px'
                                    }}>
                                      Mobile No.
                                    </th>

                                    {order.sheduled === true && (
                                      <th style={{
                                        textAlign: 'center',
                                        color: 'Black',
                                        fontWeight: 'bold',
                                        fontSize: window.innerWidth <= 370 ? '12px' : window.innerWidth <= 768 ? '13px' : '14px',
                                        padding: window.innerWidth <= 768 ? '10px 8px' : '12px 8px',
                                        borderRight: '1px solid rgba(255, 255, 255, 0.3)',
                                        minWidth: '140px'
                                      }}>
                                        Schedule Time
                                      </th>
                                    )}

                                    <th style={{
                                      textAlign: 'center',
                                      color: 'Black',
                                      fontWeight: 'bold',
                                      fontSize: window.innerWidth <= 370 ? '12px' : window.innerWidth <= 768 ? '13px' : '14px',
                                      padding: window.innerWidth <= 768 ? '10px 8px' : '12px 8px',
                                      borderRight: '1px solid rgba(255, 255, 255, 0.3)',
                                      minWidth: '160px'
                                    }}>
                                      Item
                                    </th>
                                    <th style={{
                                      textAlign: 'center',
                                      color: 'Black',
                                      fontWeight: 'bold',
                                      fontSize: window.innerWidth <= 370 ? '12px' : window.innerWidth <= 768 ? '13px' : '14px',
                                      padding: window.innerWidth <= 768 ? '10px 8px' : '12px 8px',
                                      minWidth: '80px',
                                      position: 'sticky',
                                      right: 0,
                                      background: '#b15cd6',
                                      zIndex: 11
                                    }}>
                                      Qty
                                    </th>
                                  </tr>
                                </thead>

                                <tbody>
                                  {/* VALUES ROW */}
                                  <tr style={{
                                    borderBottom: '1px solid rgba(255, 255, 255, 0.2)'
                                  }}>
                                    <td style={{
                                      textAlign: 'center',
                                      padding: window.innerWidth <= 768 ? '12px 8px' : '15px 8px',
                                      borderRight: '1px solid rgba(255, 255, 255, 0.2)',
                                      fontSize: window.innerWidth <= 500 ? "0.9rem" : "1rem",
                                      color: '#ffffffff',
                                      fontWeight: '600',
                                      verticalAlign: 'middle',
                                      minWidth: '120px',
                                      position: 'sticky',
                                      left: 0,
                                      background: (() => {
                                        const normalized = (order.orderType || "").trim().toLowerCase();
                                        switch (normalized) {
                                          case "dine_in": return "#1E90FF";
                                          case "takeaway": return "#FF6347";
                                          case "delivery": return "#20B2AA";
                                          case "table_dine_in": return "#2051b2ff";
                                          default: return "#b15cd6";
                                        }
                                      })(),
                                      zIndex: 9
                                    }}>
                                      {order.deliveryUserName || order.userName || "Guest"}
                                    </td>
                                    <td style={{
                                      textAlign: 'center',
                                      padding: window.innerWidth <= 768 ? '12px 8px' : '15px 8px',
                                      borderRight: '1px solid rgba(255, 255, 255, 0.2)',
                                      fontSize: window.innerWidth <= 500 ? "0.9rem" : "1rem",
                                      color: '#ffffffff',
                                      fontWeight: '600',
                                      verticalAlign: 'middle',
                                      minWidth: '120px'
                                    }}>
                                      {order.mobileNo || "-"}
                                    </td>

                                    {/* ✅ ADD THIS: Schedule Time cell - only show if order.sheduled === true */}
                                    {order.sheduled === true && (
                                      <td style={{
                                        textAlign: 'center',
                                        padding: window.innerWidth <= 768 ? '12px 8px' : '15px 8px',
                                        borderRight: '1px solid rgba(255, 255, 255, 0.2)',
                                        fontSize: window.innerWidth <= 500 ? "0.85rem" : "0.95rem",
                                        color: '#ffffffff',
                                        fontWeight: '600',
                                        verticalAlign: 'middle',
                                        minWidth: '140px',
                                        wordBreak: 'break-all'
                                      }}>
                                        {formatScheduleDateTime(order)}
                                      </td>
                                    )}
                                    <td style={{
                                      textAlign: 'center',
                                      padding: window.innerWidth <= 768 ? '12px 8px' : '15px 8px',
                                      borderRight: '1px solid rgba(255, 255, 255, 0.2)',
                                      verticalAlign: 'middle',
                                      minWidth: '160px'
                                    }}>
                                      <div style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'start',
                                        gap: window.innerWidth <= 768 ? '8px' : '10px'
                                      }}>
                                        {orderItems
                                          .filter((item) => item.status === "Okay" || item.orderType === "TABLE_DINE_IN")
                                          .map((item, index) => (
                                            <div
                                              key={index}
                                              style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: window.innerWidth <= 768 ? '8px' : '10px',
                                                justifyContent: 'center',
                                                padding: '4px 0'
                                              }}
                                            >
                                              <input
                                                type="checkbox"
                                                checked={!!selectedItems[item.listId || item.id || index]}
                                                onChange={() => {
                                                  const id = item.listId || item.id || index;
                                                  setSelectedItems(prev => ({
                                                    ...prev,
                                                    [id]: !prev[id]
                                                  }));
                                                }}
                                                style={{
                                                  cursor: 'pointer',
                                                  width: window.innerWidth <= 768 ? '16px' : '18px',
                                                  height: window.innerWidth <= 768 ? '16px' : '18px',
                                                  accentColor: '#b15cd6',
                                                  flexShrink: 0
                                                }}
                                              />
                                              <span style={{
                                                fontSize: window.innerWidth <= 500 ? "0.8rem" : "0.9rem",
                                                color: '#ffffffff',
                                                fontWeight: '500',
                                                whiteSpace: "nowrap",
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                maxWidth: window.innerWidth <= 768 ? '130px' : '150px'
                                              }}>
                                                {item.dishName}
                                              </span>
                                            </div>
                                          ))}
                                      </div>
                                    </td>
                                    <td style={{
                                      textAlign: 'center',
                                      padding: window.innerWidth <= 768 ? '12px 8px' : '15px 8px',
                                      verticalAlign: 'middle',
                                      minWidth: '80px',
                                      position: 'sticky',
                                      right: 0,
                                      background: (() => {
                                        const normalized = (order.orderType || "").trim().toLowerCase();
                                        switch (normalized) {
                                          case "dine_in": return "#1E90FF";
                                          case "takeaway": return "#FF6347";
                                          case "delivery": return "#20B2AA";
                                          case "table_dine_in": return "#2051b2ff";
                                          default: return "#b15cd6";
                                        }
                                      })(),
                                      zIndex: 9
                                    }}>
                                      <div style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        gap: window.innerWidth <= 768 ? '8px' : '10px'
                                      }}>
                                        {orderItems
                                          .filter((item) => item.status === "Okay" || item.orderType === "TABLE_DINE_IN")
                                          .map((item, index) => (
                                            <div
                                              key={index}
                                              style={{
                                                fontSize: window.innerWidth <= 500 ? "0.9rem" : "1rem",
                                                color: '#ffffffff',
                                                fontWeight: 'bold',
                                                padding: '4px 0',
                                                minWidth: '25px'
                                              }}
                                            >
                                              {item.quantity || 1}
                                            </div>
                                          ))}
                                      </div>
                                    </td>
                                  </tr>

                                  {/* ADDRESS ROW */}
                                  <tr>
                                    <td colSpan={order.sheduled === true ? "5" : "4"} style={{
                                      padding: '0px',
                                      background: 'rgba(177, 92, 214, 0.1)',
                                      minWidth: window.innerWidth <= 768 ? '650px' : 'auto'
                                    }}>
                                      <div style={{
                                        display: window.innerWidth < 500 ? 'flex' : 'grid',
                                        gridTemplateColumns: window.innerWidth <= 768 ? '1fr' : 'auto 1fr',
                                        alignItems: 'center',
                                        gap: '0px',
                                        width: '100%'
                                      }}>
                                        <div style={{
                                          fontSize: window.innerWidth < 769 ? "13px" : '14px',
                                          color: 'black',
                                          fontWeight: 'bold',
                                          whiteSpace: 'nowrap',
                                          padding: window.innerWidth <= 768 ? '10px 12px' : '8px 12px',
                                          borderRadius: '4px',
                                          border: '0px solid #b15cd6',
                                          minWidth: window.innerWidth <= 768 ? '100px' : 'auto'
                                        }}>
                                          Address:
                                        </div>
                                        <div className='borderleft' style={{
                                          fontSize: window.innerWidth <= 500 ? "0.95rem" : "1.05rem",
                                          color: '#ffffffff',
                                          fontWeight: '500',
                                          wordBreak: 'break-word',
                                          alignItems: "center",
                                          display: "flex",
                                          justifyContent: "center",
                                          padding: window.innerWidth <= 768 ? '10px 15px' : '10px 15px',
                                          borderRadius: '0px',
                                          minWidth: window.innerWidth <= 768 ? '550px' : 'auto'
                                        }}>
                                          {order.deliveryAddress || "-"}
                                        </div>
                                      </div>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </>
                      )}

                      <div style={{
                        ...styles.tracker,
                        display: 'flex',
                        justifyContent: 'center',
                        flexDirection: isMobile ? 'column' : 'row',
                        gap: isMobile ? '5px' : '0px',
                        alignItems: 'center',
                        fontSize: window.innerWidth < 1300 ? "0.9rem" : "1rem",
                      }}>
                        {orderStages.map((stage, index) => {
                          const stageOrder = orderStages;
                          const currentStageIndex = getCurrentStageIndex(order);
                          const isCompleted = index <= currentStageIndex;
                          const isFutureStage = index > currentStageIndex;
                          const hasSelectedItems = order.orderType === "TABLE_DINE_IN"
                            ? getSelectedDineInItemIds(order).length > 0
                            : true;
                          const isDeliveryAndDeliveredStage = (order.orderType === "DELIVERY" && stage === "Delivered");
                          const isClickable = isFutureStage && hasSelectedItems && !isDeliveryAndDeliveredStage;

                          return (
                            <React.Fragment key={index}>
                              <div
                                onClick={() => isClickable && handleStageClick(order, stage, index)}
                                style={{
                                  ...styles.statusBox,
                                  backgroundColor: isCompleted
                                    ? "green"
                                    : isClickable
                                      ? (index === currentStageIndex + 1 ? "#ffd900ff" : "#f0f0f0ff")
                                      : "#f0f0f0ff",
                                  color: isCompleted ? "white" : "black",
                                  borderRadius: "6px",
                                  padding: window.innerWidth < 1100 ? "6px 10px" : "8px 12px",
                                  fontWeight: "bold",
                                  textTransform: "uppercase",
                                  transition: "all 0.3s ease",
                                  cursor: isClickable ? "pointer" : "default",
                                  boxShadow: isClickable ? "0 2px 8px rgba(0,0,0,0.3)" : "none",
                                  position: "relative",
                                  transform: isClickable ? "translateY(-2px)" : "none",
                                  border: isClickable ? (index > currentStageIndex + 1 ? "0px dashed #ff9800" : "0px solid #ff4081") : "2px solid transparent",
                                }}
                                onMouseEnter={(e) => {
                                  if (isClickable) {
                                    e.currentTarget.style.transform = "scale(1.05)";
                                    if (index > currentStageIndex + 1) {
                                      e.currentTarget.style.boxShadow = "0 4px 12px rgba(255, 152, 0, 0.5)";
                                    }
                                  }
                                }}
                                onMouseLeave={(e) => {
                                  if (isClickable) {
                                    e.currentTarget.style.transform = "translateY(-2px)";
                                    if (index > currentStageIndex + 1) {
                                      e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.3)";
                                    }
                                  }
                                }}
                                title={isClickable
                                  ? `Click to mark as ${stage}${index > currentStageIndex + 1 ? " (Skip ahead)" : ""}`
                                  : isCompleted ? `Already ${stage}` : ""
                                }
                              >
                                {stage}
                              </div>
                              {index !== orderStages.length - 1 && <span style={styles.arrow}></span>}
                            </React.Fragment>
                          );
                        })}
                      </div>
                    </div>
                  );
                })}
              </div>
            );
          })()}
        </div>

        {/* Add CSS for spinner animation */}
        <style>
          {`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}
        </style>
      </div>
    ),
    // Schedule: renderWithOrdersSidebar(<Schedule />),

    History: (<StandardOrderStatus
        vendorId={vendorId}
        statusOrders={statusOrders}
        isLoadingStatus={isLoadingStatus}
        currentPage={currentPage}
        totalPages={totalPages}
        selectedDate={selectedDate}
        searchQuery={searchQuery}
        onPrintReceipt={handlePrintReceipt}
        onExportCSV={exportAllOrdersForCSV}
        onDateChange={setSelectedDate}
        onSearchChange={(value) => {
          setSearchQuery(value);
          setCurrentPage(0);
        }}
        onSearch={handleSearch}
        onPageChange={setCurrentPage}
        isPrinting={isPrinting}
        printingOrderId={printingOrderId}
      />
    ),

  };
  const handleTabChange = (tab) => {
    setTabLoading(true);
    setActiveTab(tab);
    setTimeout(() => setTabLoading(false), 300);
  };

  return (

    <div>

      <style>{`
        .main-container {
          padding: 20px;
          display: flex;
          flex-direction: column;

        }
@media screen and (min-width: 768px) {
         .tabs-wrapperyyy {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 10px;
          margin-left:0px;
          margin-top:0px;
}
      }


/* Mobile view ke liye (max-width 768px ya 600px aapke design ke hisaab se) */
@media screen and (max-width: 768px) {
  .tabs-wrapper {
    margin-left: 0;

  }
       .tabs-wrapperyyy {
      display: flex;
          flex-direction: column;
          align-items: center;
          gap: 10px;
          margin-left:0px;
          margin-top:-30px;
}
            .tab-content {
          width: 100%;
          max-width:944px;


        }
}


        .tab-buttons {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          gap: 10px;
          margin-top:0px;

        }

        .tab-button {
          border: none;
          border-radius: 8px;
          width: auto;
          padding:9px 12px;
          // height: 40px;
          background-color: #d9d9d9;
          color: #000;
          font-weight: bold;
          cursor: pointer;
          transition: background-color 0.3s ease;
        }

        .tab-button.active {
          color:white;
          background-color: #b15cd6;
        }



        .sidebar {
          margin-top: 30px;
          max-height: 600px;
          overflow-y: auto;
        }

        .card {
          width: 100%;
          max-width: 300px;
          height: 120px;
          background: #ccc;
          border-radius: 8px;
          box-shadow: 0px 2px 4px rgba(0,0,0,0.1);
          margin: 10px auto;
          position: relative;
          padding: 10px;
        }

        .card h5, .card p {
          color: white;
          margin: -18 !imortanant;
        }




        @media (min-width: 768px) {
          .main-container {
            flex-direction: row;
            justify-content: space-between;
          }
  .tab-content {
          margin-top: 0px;
          width: 100%;
          max-width:944px;

        }

         .left-column {
    padding-right: 0;
    display: flex;
    flex-direction: column;         /* stack children vertically */

    justify-content: center;        /* center vertically */
    text-align: start;
    margin: 0 auto;
  }

          .right-column {
            width: 30%;
            position: sticky;
            top: -30px;
            max-height: 700px;
            overflow-y: auto;
          }

          .card {
            margin-left: 0;
          }
            .tabs-wrapperyyy{
            margin-left:none

            }

        }

        /* Hide native scrollbars */
        .sidebar::-webkit-scrollbar,
        .left-column::-webkit-scrollbar {
          width: 0px;
          background: transparent;
        }


/* Media queries for different screen heights */
@media (max-height: 400px) {
  .tab-content {
    height: 70vh !important;
  }
}

@media (min-height: 401px) and (max-height: 500px) {
  .tab-content {
    height: 60vh !important;
  }
}

@media (min-height: 501px) and (max-height: 600px) {
  .tab-content {
    height: 60vh !important;
  }
}

/* For screens taller than 600px */
@media (min-height: 601px)and (max-height: 700px) {
  .tab-content {
    height: 65vh !important; /* Or use your containerHeight value */
  }
}
  @media (min-height : 701px){
  .tab-content {
    height: 70vh !important; /* Or use your containerHeight value */
  }
  }
  .borderleft{
    border-left:1px solid #bfbfbf !important;
    }
     @media (max-width: 768px) {
    .tab-buttons {
        margin-top: 16px !important;
    }
}
      `}</style>

      <div className="container-fluid">
        <div className="row">
          {/* <div className="col-lg-2 col-md-12 col-sm-12 col-12"></div> */}
          <div className="col-lg-12 col-md-12 col-sm-12 col-12">

            {/* Left Section */}
            <div className="left-column" style={{}}>
              <div className="tabs-wrapperyyy ">

                <div className="tab-buttons" style={{ marginLeft: "0%" }}>
                  {Object.keys(tabContent).map((label) => (
                    <button
                      key={label}
                      className={`tab-button ${activeTab === label ? "active" : ""}`}
                      onClick={() => handleTabChange(label)}
                      style={{ minWidth: window.innerWidth < 380 ? " " : "100px" }}
                    >
                      {label}
                    </button>
                  ))}
                </div>
                <div className="tab-content" style={{
                  msOverflowStyle: "none",
                  maxWidth: '944px',
                  width: window.innerWidth < 500 ? "90vw" : " ",
                  position: 'relative', // Add this
                  minHeight: '200px' // Add minimum height
                }}>
                  {tabLoading ? (
                    // Loader overlay
                    <div style={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      backgroundColor: 'rgba(255, 255, 255, 0.8)',
                      zIndex: 1000,
                      borderRadius: '10px'
                    }}>
                      <div style={{
                        width: '40px',
                        height: '40px',
                        border: '4px solid #f3f3f3',
                        borderTop: '4px solid #b15cd6',
                        borderRadius: '50%',
                        animation: 'spin 1s linear infinite'
                      }}></div>

                      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
                    </div>
                  ) : null}

                  {tabContent[activeTab]}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


  );
};

export default Standardorder;